// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/shadcn/dist/tailwind.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/hero-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Sponsor-section.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/ai-section.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @tailwind base;
@tailwind components;
@tailwind utilities; */
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
:root {
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;
    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;
    --primary: 221.2 83.2% 53.3%;
    --primary-foreground: 210 40% 98%;
    --secondary: 210 40% 96%;
    --secondary-foreground: 222.2 84% 4.9%;
    --muted: 210 40% 96%;
    --muted-foreground: 215.4 16.3% 46.9%;
    --accent: 210 40% 96%;
    --accent-foreground: 222.2 84% 4.9%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;
    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 221.2 83.2% 53.3%;
    --chart-1: 12 76% 61%;
    --chart-2: 173 58% 39%;
    --chart-3: 197 37% 24%;
    --chart-4: 43 74% 66%;
    --chart-5: 27 87% 67%;
    --radius: 0.5rem;
  }
.dark {
    --background: 222.2 84% 4.9%;
    --foreground: 210 40% 98%;
    --card: 222.2 84% 4.9%;
    --card-foreground: 210 40% 98%;
    --popover: 222.2 84% 4.9%;
    --popover-foreground: 210 40% 98%;
    --primary: 217.2 91.2% 59.8%;
    --primary-foreground: 222.2 84% 4.9%;
    --secondary: 217.2 32.6% 17.5%;
    --secondary-foreground: 210 40% 98%;
    --muted: 217.2 32.6% 17.5%;
    --muted-foreground: 215 20.2% 65.1%;
    --accent: 217.2 32.6% 17.5%;
    --accent-foreground: 210 40% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 210 40% 98%;
    --border: 217.2 32.6% 17.5%;
    --input: 217.2 32.6% 17.5%;
    --ring: 224.3 76.3% 94.1%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
  }
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
@media (min-width: 640px) {
    .\\!container {
        max-width: 640px !important;
    }
    .container {
        max-width: 640px;
    }
}
@media (min-width: 768px) {
    .\\!container {
        max-width: 768px !important;
    }
    .container {
        max-width: 768px;
    }
}
@media (min-width: 1024px) {
    .\\!container {
        max-width: 1024px !important;
    }
    .container {
        max-width: 1024px;
    }
}
@media (min-width: 1280px) {
    .\\!container {
        max-width: 1280px !important;
    }
    .container {
        max-width: 1280px;
    }
}
@media (min-width: 1536px) {
    .\\!container {
        max-width: 1536px !important;
    }
    .container {
        max-width: 1536px;
    }
}
.sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border-width: 0 !important;
}
.pointer-events-none {
    pointer-events: none !important;
}
.pointer-events-auto {
    pointer-events: auto !important;
}
.\\!visible {
    visibility: visible !important;
}
.visible {
    visibility: visible !important;
}
.invisible {
    visibility: hidden !important;
}
.collapse {
    visibility: collapse !important;
}
.static {
    position: static !important;
}
.fixed {
    position: fixed !important;
}
.absolute {
    position: absolute !important;
}
.relative {
    position: relative !important;
}
.sticky {
    position: sticky !important;
}
.-inset-4 {
    inset: -1rem !important;
}
.inset-0 {
    inset: 0px !important;
}
.inset-x-0 {
    left: 0px !important;
    right: 0px !important;
}
.inset-y-0 {
    top: 0px !important;
    bottom: 0px !important;
}
.-bottom-12 {
    bottom: -3rem !important;
}
.-bottom-5 {
    bottom: -1.25rem !important;
}
.-bottom-6 {
    bottom: -1.5rem !important;
}
.-left-1\\/4 {
    left: -25% !important;
}
.-left-12 {
    left: -3rem !important;
}
.-left-2 {
    left: -0.5rem !important;
}
.-left-20 {
    left: -5rem !important;
}
.-right-0\\.5 {
    right: -0.125rem !important;
}
.-right-1\\/4 {
    right: -25% !important;
}
.-right-12 {
    right: -3rem !important;
}
.-top-0\\.5 {
    top: -0.125rem !important;
}
.-top-1\\/2 {
    top: -50% !important;
}
.-top-1\\/4 {
    top: -25% !important;
}
.-top-12 {
    top: -3rem !important;
}
.-top-3 {
    top: -0.75rem !important;
}
.bottom-0 {
    bottom: 0px !important;
}
.bottom-1\\/3 {
    bottom: 33.333333% !important;
}
.bottom-3 {
    bottom: 0.75rem !important;
}
.bottom-4 {
    bottom: 1rem !important;
}
.bottom-full {
    bottom: 100% !important;
}
.left-0 {
    left: 0px !important;
}
.left-1 {
    left: 0.25rem !important;
}
.left-1\\/2 {
    left: 50% !important;
}
.left-1\\/3 {
    left: 33.333333% !important;
}
.left-2 {
    left: 0.5rem !important;
}
.left-3 {
    left: 0.75rem !important;
}
.left-4 {
    left: 1rem !important;
}
.left-6 {
    left: 1.5rem !important;
}
.left-\\[50\\%\\] {
    left: 50% !important;
}
.left-\\[52\\%\\] {
    left: 52% !important;
}
.right-0 {
    right: 0px !important;
}
.right-1 {
    right: 0.25rem !important;
}
.right-1\\/4 {
    right: 25% !important;
}
.right-2 {
    right: 0.5rem !important;
}
.right-3 {
    right: 0.75rem !important;
}
.right-4 {
    right: 1rem !important;
}
.top-0 {
    top: 0px !important;
}
.top-1 {
    top: 0.25rem !important;
}
.top-1\\.5 {
    top: 0.375rem !important;
}
.top-1\\/2 {
    top: 50% !important;
}
.top-1\\/4 {
    top: 25% !important;
}
.top-2 {
    top: 0.5rem !important;
}
.top-3\\.5 {
    top: 0.875rem !important;
}
.top-4 {
    top: 1rem !important;
}
.top-\\[13px\\] {
    top: 13px !important;
}
.top-\\[1px\\] {
    top: 1px !important;
}
.top-\\[30\\%\\] {
    top: 30% !important;
}
.top-\\[36px\\] {
    top: 36px !important;
}
.top-\\[50\\%\\] {
    top: 50% !important;
}
.top-\\[60\\%\\] {
    top: 60% !important;
}
.top-full {
    top: 100% !important;
}
.isolate {
    isolation: isolate !important;
}
.z-0 {
    z-index: 0 !important;
}
.z-10 {
    z-index: 10 !important;
}
.z-20 {
    z-index: 20 !important;
}
.z-50 {
    z-index: 50 !important;
}
.z-\\[100000\\] {
    z-index: 100000 !important;
}
.z-\\[1000\\] {
    z-index: 1000 !important;
}
.z-\\[1001\\] {
    z-index: 1001 !important;
}
.z-\\[10\\] {
    z-index: 10 !important;
}
.z-\\[1200\\] {
    z-index: 1200 !important;
}
.z-\\[1300\\] {
    z-index: 1300 !important;
}
.z-\\[1400\\] {
    z-index: 1400 !important;
}
.z-\\[1\\] {
    z-index: 1 !important;
}
.z-\\[800\\] {
    z-index: 800 !important;
}
.z-\\[850\\] {
    z-index: 850 !important;
}
.z-\\[900\\] {
    z-index: 900 !important;
}
.z-\\[9998\\] {
    z-index: 9998 !important;
}
.z-\\[99999\\] {
    z-index: 99999 !important;
}
.z-\\[9999\\] {
    z-index: 9999 !important;
}
.order-1 {
    order: 1 !important;
}
.order-2 {
    order: 2 !important;
}
.col-start-2 {
    grid-column-start: 2 !important;
}
.row-span-2 {
    grid-row: span 2 / span 2 !important;
}
.row-start-1 {
    grid-row-start: 1 !important;
}
.m-0 {
    margin: 0px !important;
}
.-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
}
.mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
}
.mx-3\\.5 {
    margin-left: 0.875rem !important;
    margin-right: 0.875rem !important;
}
.mx-4 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
}
.mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}
.my-0\\.5 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
}
.my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
}
.my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
}
.my-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
}
.my-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
}
.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
}
.-ml-4 {
    margin-left: -1rem !important;
}
.-mt-0\\.5 {
    margin-top: -0.125rem !important;
}
.-mt-1 {
    margin-top: -0.25rem !important;
}
.-mt-4 {
    margin-top: -1rem !important;
}
.mb-0\\.5 {
    margin-bottom: 0.125rem !important;
}
.mb-1 {
    margin-bottom: 0.25rem !important;
}
.mb-1\\.5 {
    margin-bottom: 0.375rem !important;
}
.mb-10 {
    margin-bottom: 2.5rem !important;
}
.mb-12 {
    margin-bottom: 3rem !important;
}
.mb-16 {
    margin-bottom: 4rem !important;
}
.mb-2 {
    margin-bottom: 0.5rem !important;
}
.mb-2\\.5 {
    margin-bottom: 0.625rem !important;
}
.mb-20 {
    margin-bottom: 5rem !important;
}
.mb-3 {
    margin-bottom: 0.75rem !important;
}
.mb-32 {
    margin-bottom: 8rem !important;
}
.mb-4 {
    margin-bottom: 1rem !important;
}
.mb-5 {
    margin-bottom: 1.25rem !important;
}
.mb-6 {
    margin-bottom: 1.5rem !important;
}
.mb-8 {
    margin-bottom: 2rem !important;
}
.mb-\\[2px\\] {
    margin-bottom: 2px !important;
}
.ml-1 {
    margin-left: 0.25rem !important;
}
.ml-2 {
    margin-left: 0.5rem !important;
}
.ml-auto {
    margin-left: auto !important;
}
.mr-2 {
    margin-right: 0.5rem !important;
}
.mr-3 {
    margin-right: 0.75rem !important;
}
.mt-0 {
    margin-top: 0px !important;
}
.mt-0\\.5 {
    margin-top: 0.125rem !important;
}
.mt-1 {
    margin-top: 0.25rem !important;
}
.mt-1\\.5 {
    margin-top: 0.375rem !important;
}
.mt-10 {
    margin-top: 2.5rem !important;
}
.mt-12 {
    margin-top: 3rem !important;
}
.mt-16 {
    margin-top: 4rem !important;
}
.mt-2 {
    margin-top: 0.5rem !important;
}
.mt-20 {
    margin-top: 5rem !important;
}
.mt-3 {
    margin-top: 0.75rem !important;
}
.mt-4 {
    margin-top: 1rem !important;
}
.mt-5 {
    margin-top: 1.25rem !important;
}
.mt-6 {
    margin-top: 1.5rem !important;
}
.mt-8 {
    margin-top: 2rem !important;
}
.mt-auto {
    margin-top: auto !important;
}
.box-border {
    box-sizing: border-box !important;
}
.line-clamp-1 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
}
.line-clamp-2 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2 !important;
}
.block {
    display: block !important;
}
.inline-block {
    display: inline-block !important;
}
.inline {
    display: inline !important;
}
.flex {
    display: flex !important;
}
.inline-flex {
    display: inline-flex !important;
}
.table {
    display: table !important;
}
.table-caption {
    display: table-caption !important;
}
.table-cell {
    display: table-cell !important;
}
.table-row {
    display: table-row !important;
}
.grid {
    display: grid !important;
}
.hidden {
    display: none !important;
}
.aspect-\\[3\\/4\\] {
    aspect-ratio: 3/4 !important;
}
.aspect-\\[4\\/3\\] {
    aspect-ratio: 4/3 !important;
}
.aspect-square {
    aspect-ratio: 1 / 1 !important;
}
.aspect-video {
    aspect-ratio: 16 / 9 !important;
}
.size-10 {
    width: 2.5rem !important;
    height: 2.5rem !important;
}
.size-12 {
    width: 3rem !important;
    height: 3rem !important;
}
.size-16 {
    width: 4rem !important;
    height: 4rem !important;
}
.size-2 {
    width: 0.5rem !important;
    height: 0.5rem !important;
}
.size-2\\.5 {
    width: 0.625rem !important;
    height: 0.625rem !important;
}
.size-3 {
    width: 0.75rem !important;
    height: 0.75rem !important;
}
.size-3\\.5 {
    width: 0.875rem !important;
    height: 0.875rem !important;
}
.size-4 {
    width: 1rem !important;
    height: 1rem !important;
}
.size-5 {
    width: 1.25rem !important;
    height: 1.25rem !important;
}
.size-7 {
    width: 1.75rem !important;
    height: 1.75rem !important;
}
.size-8 {
    width: 2rem !important;
    height: 2rem !important;
}
.size-9 {
    width: 2.25rem !important;
    height: 2.25rem !important;
}
.size-full {
    width: 100% !important;
    height: 100% !important;
}
.\\!h-\\[32px\\] {
    height: 32px !important;
}
.\\!h-\\[38px\\] {
    height: 38px !important;
}
.\\!h-auto {
    height: auto !important;
}
.h-0 {
    height: 0px !important;
}
.h-1 {
    height: 0.25rem !important;
}
.h-1\\.5 {
    height: 0.375rem !important;
}
.h-10 {
    height: 2.5rem !important;
}
.h-11 {
    height: 2.75rem !important;
}
.h-12 {
    height: 3rem !important;
}
.h-14 {
    height: 3.5rem !important;
}
.h-16 {
    height: 4rem !important;
}
.h-2 {
    height: 0.5rem !important;
}
.h-2\\.5 {
    height: 0.625rem !important;
}
.h-24 {
    height: 6rem !important;
}
.h-3 {
    height: 0.75rem !important;
}
.h-3\\.5 {
    height: 0.875rem !important;
}
.h-32 {
    height: 8rem !important;
}
.h-36 {
    height: 9rem !important;
}
.h-4 {
    height: 1rem !important;
}
.h-48 {
    height: 12rem !important;
}
.h-5 {
    height: 1.25rem !important;
}
.h-6 {
    height: 1.5rem !important;
}
.h-64 {
    height: 16rem !important;
}
.h-7 {
    height: 1.75rem !important;
}
.h-8 {
    height: 2rem !important;
}
.h-9 {
    height: 2.25rem !important;
}
.h-\\[1\\.15rem\\] {
    height: 1.15rem !important;
}
.h-\\[100px\\] {
    height: 100px !important;
}
.h-\\[100vh\\] {
    height: 100vh !important;
}
.h-\\[11px\\] {
    height: 11px !important;
}
.h-\\[120\\%\\] {
    height: 120% !important;
}
.h-\\[13\\.33px\\] {
    height: 13.33px !important;
}
.h-\\[150\\%\\] {
    height: 150% !important;
}
.h-\\[152px\\] {
    height: 152px !important;
}
.h-\\[153px\\] {
    height: 153px !important;
}
.h-\\[180px\\] {
    height: 180px !important;
}
.h-\\[18px\\] {
    height: 18px !important;
}
.h-\\[20\\.91px\\] {
    height: 20.91px !important;
}
.h-\\[200px\\] {
    height: 200px !important;
}
.h-\\[20px\\] {
    height: 20px !important;
}
.h-\\[21px\\] {
    height: 21px !important;
}
.h-\\[220px\\] {
    height: 220px !important;
}
.h-\\[22px\\] {
    height: 22px !important;
}
.h-\\[300px\\] {
    height: 300px !important;
}
.h-\\[30px\\] {
    height: 30px !important;
}
.h-\\[30vh\\] {
    height: 30vh !important;
}
.h-\\[32px\\] {
    height: 32px !important;
}
.h-\\[36px\\] {
    height: 36px !important;
}
.h-\\[38px\\] {
    height: 38px !important;
}
.h-\\[3px\\] {
    height: 3px !important;
}
.h-\\[400px\\] {
    height: 400px !important;
}
.h-\\[42px\\] {
    height: 42px !important;
}
.h-\\[44px\\] {
    height: 44px !important;
}
.h-\\[48px\\] {
    height: 48px !important;
}
.h-\\[50px\\] {
    height: 50px !important;
}
.h-\\[52px\\] {
    height: 52px !important;
}
.h-\\[60px\\] {
    height: 60px !important;
}
.h-\\[85vh\\] {
    height: 85vh !important;
}
.h-\\[96\\%\\] {
    height: 96% !important;
}
.h-\\[calc\\(100\\%-1px\\)\\] {
    height: calc(100% - 1px) !important;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
    height: var(--radix-navigation-menu-viewport-height) !important;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height) !important;
}
.h-auto {
    height: auto !important;
}
.h-fit {
    height: fit-content !important;
}
.h-full {
    height: 100% !important;
}
.h-px {
    height: 1px !important;
}
.h-screen {
    height: 100vh !important;
}
.h-svh {
    height: 100svh !important;
}
.max-h-40 {
    max-height: 10rem !important;
}
.max-h-48 {
    max-height: 12rem !important;
}
.max-h-56 {
    max-height: 14rem !important;
}
.max-h-7 {
    max-height: 1.75rem !important;
}
.max-h-8 {
    max-height: 2rem !important;
}
.max-h-9 {
    max-height: 2.25rem !important;
}
.max-h-\\[120px\\] {
    max-height: 120px !important;
}
.max-h-\\[160px\\] {
    max-height: 160px !important;
}
.max-h-\\[20px\\] {
    max-height: 20px !important;
}
.max-h-\\[300px\\] {
    max-height: 300px !important;
}
.max-h-\\[38px\\] {
    max-height: 38px !important;
}
.max-h-\\[8\\.5rem\\] {
    max-height: 8.5rem !important;
}
.max-h-\\[90vh\\] {
    max-height: 90vh !important;
}
.\\!min-h-0 {
    min-height: 0px !important;
}
.\\!min-h-\\[24px\\] {
    min-height: 24px !important;
}
.min-h-0 {
    min-height: 0px !important;
}
.min-h-16 {
    min-height: 4rem !important;
}
.min-h-4 {
    min-height: 1rem !important;
}
.min-h-7 {
    min-height: 1.75rem !important;
}
.min-h-8 {
    min-height: 2rem !important;
}
.min-h-9 {
    min-height: 2.25rem !important;
}
.min-h-\\[180px\\] {
    min-height: 180px !important;
}
.min-h-\\[20px\\] {
    min-height: 20px !important;
}
.min-h-\\[24px\\] {
    min-height: 24px !important;
}
.min-h-\\[280px\\] {
    min-height: 280px !important;
}
.min-h-\\[32px\\] {
    min-height: 32px !important;
}
.min-h-\\[36px\\] {
    min-height: 36px !important;
}
.min-h-\\[38px\\] {
    min-height: 38px !important;
}
.min-h-\\[44px\\] {
    min-height: 44px !important;
}
.min-h-\\[48px\\] {
    min-height: 48px !important;
}
.min-h-\\[68px\\] {
    min-height: 68px !important;
}
.min-h-\\[72px\\] {
    min-height: 72px !important;
}
.min-h-screen {
    min-height: 100vh !important;
}
.min-h-svh {
    min-height: 100svh !important;
}
.w-0 {
    width: 0px !important;
}
.w-0\\.5 {
    width: 0.125rem !important;
}
.w-1 {
    width: 0.25rem !important;
}
.w-1\\.5 {
    width: 0.375rem !important;
}
.w-1\\/2 {
    width: 50% !important;
}
.w-1\\/3 {
    width: 33.333333% !important;
}
.w-1\\/4 {
    width: 25% !important;
}
.w-10 {
    width: 2.5rem !important;
}
.w-11\\/12 {
    width: 91.666667% !important;
}
.w-12 {
    width: 3rem !important;
}
.w-14 {
    width: 3.5rem !important;
}
.w-16 {
    width: 4rem !important;
}
.w-2 {
    width: 0.5rem !important;
}
.w-2\\.5 {
    width: 0.625rem !important;
}
.w-20 {
    width: 5rem !important;
}
.w-24 {
    width: 6rem !important;
}
.w-3 {
    width: 0.75rem !important;
}
.w-3\\.5 {
    width: 0.875rem !important;
}
.w-3\\/4 {
    width: 75% !important;
}
.w-32 {
    width: 8rem !important;
}
.w-4 {
    width: 1rem !important;
}
.w-40 {
    width: 10rem !important;
}
.w-48 {
    width: 12rem !important;
}
.w-5 {
    width: 1.25rem !important;
}
.w-6 {
    width: 1.5rem !important;
}
.w-64 {
    width: 16rem !important;
}
.w-7 {
    width: 1.75rem !important;
}
.w-72 {
    width: 18rem !important;
}
.w-8 {
    width: 2rem !important;
}
.w-9 {
    width: 2.25rem !important;
}
.w-\\[100px\\] {
    width: 100px !important;
}
.w-\\[11px\\] {
    width: 11px !important;
}
.w-\\[120\\%\\] {
    width: 120% !important;
}
.w-\\[120px\\] {
    width: 120px !important;
}
.w-\\[13\\.33px\\] {
    width: 13.33px !important;
}
.w-\\[150\\%\\] {
    width: 150% !important;
}
.w-\\[170px\\] {
    width: 170px !important;
}
.w-\\[171px\\] {
    width: 171px !important;
}
.w-\\[18px\\] {
    width: 18px !important;
}
.w-\\[200px\\] {
    width: 200px !important;
}
.w-\\[210px\\] {
    width: 210px !important;
}
.w-\\[220px\\] {
    width: 220px !important;
}
.w-\\[223px\\] {
    width: 223px !important;
}
.w-\\[22px\\] {
    width: 22px !important;
}
.w-\\[240px\\] {
    width: 240px !important;
}
.w-\\[246px\\] {
    width: 246px !important;
}
.w-\\[260px\\] {
    width: 260px !important;
}
.w-\\[280px\\] {
    width: 280px !important;
}
.w-\\[2px\\] {
    width: 2px !important;
}
.w-\\[300px\\] {
    width: 300px !important;
}
.w-\\[30px\\] {
    width: 30px !important;
}
.w-\\[31px\\] {
    width: 31px !important;
}
.w-\\[35\\%\\] {
    width: 35% !important;
}
.w-\\[3px\\] {
    width: 3px !important;
}
.w-\\[400px\\] {
    width: 400px !important;
}
.w-\\[420px\\] {
    width: 420px !important;
}
.w-\\[42px\\] {
    width: 42px !important;
}
.w-\\[45\\%\\] {
    width: 45% !important;
}
.w-\\[500px\\] {
    width: 500px !important;
}
.w-\\[55\\%\\] {
    width: 55% !important;
}
.w-\\[66px\\] {
    width: 66px !important;
}
.w-\\[72px\\] {
    width: 72px !important;
}
.w-\\[85vw\\] {
    width: 85vw !important;
}
.w-\\[90\\%\\] {
    width: 90% !important;
}
.w-\\[91px\\] {
    width: 91px !important;
}
.w-\\[calc\\(100\\%-1\\.5rem\\)\\] {
    width: calc(100% - 1.5rem) !important;
}
.w-\\[min\\(100\\%\\2c 280px\\)\\] {
    width: min(100%, 280px) !important;
}
.w-\\[min\\(100\\%\\2c 320px\\)\\] {
    width: min(100%, 320px) !important;
}
.w-\\[min\\(100vw-16px\\2c 266px\\)\\] {
    width: min(100vw - 16px, 266px) !important;
}
.w-\\[min\\(200px\\2c 80vw\\)\\] {
    width: min(200px, 80vw) !important;
}
.w-\\[min\\(55\\%\\2c 160px\\)\\] {
    width: min(55%, 160px) !important;
}
.w-\\[min\\(65\\%\\2c 200px\\)\\] {
    width: min(65%, 200px) !important;
}
.w-\\[min\\(85\\%\\2c 240px\\)\\] {
    width: min(85%, 240px) !important;
}
.w-auto {
    width: auto !important;
}
.w-fit {
    width: fit-content !important;
}
.w-full {
    width: 100% !important;
}
.w-max {
    width: max-content !important;
}
.w-px {
    width: 1px !important;
}
.min-w-0 {
    min-width: 0px !important;
}
.min-w-10 {
    min-width: 2.5rem !important;
}
.min-w-4 {
    min-width: 1rem !important;
}
.min-w-5 {
    min-width: 1.25rem !important;
}
.min-w-7 {
    min-width: 1.75rem !important;
}
.min-w-8 {
    min-width: 2rem !important;
}
.min-w-9 {
    min-width: 2.25rem !important;
}
.min-w-\\[12rem\\] {
    min-width: 12rem !important;
}
.min-w-\\[220px\\] {
    min-width: 220px !important;
}
.min-w-\\[240px\\] {
    min-width: 240px !important;
}
.min-w-\\[280px\\] {
    min-width: 280px !important;
}
.min-w-\\[36px\\] {
    min-width: 36px !important;
}
.min-w-\\[72px\\] {
    min-width: 72px !important;
}
.min-w-\\[8rem\\] {
    min-width: 8rem !important;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width) !important;
}
.min-w-full {
    min-width: 100% !important;
}
.max-w-2xl {
    max-width: 42rem !important;
}
.max-w-3xl {
    max-width: 48rem !important;
}
.max-w-48 {
    max-width: 12rem !important;
}
.max-w-4xl {
    max-width: 56rem !important;
}
.max-w-56 {
    max-width: 14rem !important;
}
.max-w-6xl {
    max-width: 72rem !important;
}
.max-w-7 {
    max-width: 1.75rem !important;
}
.max-w-7xl {
    max-width: 80rem !important;
}
.max-w-80 {
    max-width: 20rem !important;
}
.max-w-\\[120px\\] {
    max-width: 120px !important;
}
.max-w-\\[260px\\] {
    max-width: 260px !important;
}
.max-w-\\[278px\\] {
    max-width: 278px !important;
}
.max-w-\\[280px\\] {
    max-width: 280px !important;
}
.max-w-\\[320px\\] {
    max-width: 320px !important;
}
.max-w-\\[350px\\] {
    max-width: 350px !important;
}
.max-w-\\[380px\\] {
    max-width: 380px !important;
}
.max-w-\\[400px\\] {
    max-width: 400px !important;
}
.max-w-\\[42\\%\\] {
    max-width: 42% !important;
}
.max-w-\\[420px\\] {
    max-width: 420px !important;
}
.max-w-\\[440px\\] {
    max-width: 440px !important;
}
.max-w-\\[44vw\\] {
    max-width: 44vw !important;
}
.max-w-\\[480px\\] {
    max-width: 480px !important;
}
.max-w-\\[500px\\] {
    max-width: 500px !important;
}
.max-w-\\[55\\%\\] {
    max-width: 55% !important;
}
.max-w-\\[65\\%\\] {
    max-width: 65% !important;
}
.max-w-\\[70\\%\\] {
    max-width: 70% !important;
}
.max-w-\\[720px\\] {
    max-width: 720px !important;
}
.max-w-\\[72px\\] {
    max-width: 72px !important;
}
.max-w-\\[80\\%\\] {
    max-width: 80% !important;
}
.max-w-\\[85\\%\\] {
    max-width: 85% !important;
}
.max-w-\\[95\\%\\] {
    max-width: 95% !important;
}
.max-w-\\[calc\\(100\\%-2rem\\)\\] {
    max-width: calc(100% - 2rem) !important;
}
.max-w-\\[calc\\(100vw-16px\\)\\] {
    max-width: calc(100vw - 16px) !important;
}
.max-w-\\[min\\(100\\%\\2c 100\\%\\)\\] {
    max-width: min(100%, 100%) !important;
}
.max-w-\\[min\\(240px\\2c calc\\(100vw-2rem\\)\\)\\] {
    max-width: min(240px, calc(100vw - 2rem)) !important;
}
.max-w-\\[min\\(280px\\2c 90vw\\)\\] {
    max-width: min(280px, 90vw) !important;
}
.max-w-full {
    max-width: 100% !important;
}
.max-w-lg {
    max-width: 32rem !important;
}
.max-w-max {
    max-width: max-content !important;
}
.max-w-md {
    max-width: 28rem !important;
}
.max-w-none {
    max-width: none !important;
}
.max-w-xs {
    max-width: 20rem !important;
}
.flex-1 {
    flex: 1 1 !important;
}
.flex-none {
    flex: none !important;
}
.flex-shrink-0 {
    flex-shrink: 0 !important;
}
.shrink-0 {
    flex-shrink: 0 !important;
}
.flex-grow {
    flex-grow: 1 !important;
}
.flex-grow-0 {
    flex-grow: 0 !important;
}
.grow {
    flex-grow: 1 !important;
}
.grow-0 {
    flex-grow: 0 !important;
}
.basis-full {
    flex-basis: 100% !important;
}
.caption-bottom {
    caption-side: bottom !important;
}
.border-collapse {
    border-collapse: collapse !important;
}
.origin-top {
    transform-origin: top !important;
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-px {
    --tw-translate-x: -1px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-4 {
    --tw-translate-x: 1rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-px {
    --tw-translate-x: 1px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-0\\.5 {
    --tw-translate-y: 0.125rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[calc\\(-50\\%_-_2px\\)\\] {
    --tw-translate-y: calc(-50% - 2px) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-45 {
    --tw-rotate: 45deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90 {
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes bounce {
    0%, 100% {
        transform: translateY(-25%);
        animation-timing-function: cubic-bezier(0.8,0,1,1);
    }
    50% {
        transform: none;
        animation-timing-function: cubic-bezier(0,0,0.2,1);
    }
}
.animate-bounce {
    animation: bounce 1s infinite !important;
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite !important;
}
.cursor-default {
    cursor: default !important;
}
.cursor-not-allowed {
    cursor: not-allowed !important;
}
.cursor-pointer {
    cursor: pointer !important;
}
.cursor-wait {
    cursor: wait !important;
}
.touch-none {
    touch-action: none !important;
}
.select-none {
    -webkit-user-select: none !important;
            user-select: none !important;
}
.resize-none {
    resize: none !important;
}
.resize {
    resize: both !important;
}
.snap-x {
    scroll-snap-type: x var(--tw-scroll-snap-strictness) !important;
}
.snap-mandatory {
    --tw-scroll-snap-strictness: mandatory !important;
}
.snap-start {
    scroll-snap-align: start !important;
}
.scroll-my-1 {
    scroll-margin-top: 0.25rem !important;
    scroll-margin-bottom: 0.25rem !important;
}
.scroll-py-1 {
    scroll-padding-top: 0.25rem !important;
    scroll-padding-bottom: 0.25rem !important;
}
.list-decimal {
    list-style-type: decimal !important;
}
.list-disc {
    list-style-type: disc !important;
}
.list-none {
    list-style-type: none !important;
}
.auto-rows-min {
    grid-auto-rows: min-content !important;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}
.grid-cols-\\[0_1fr\\] {
    grid-template-columns: 0 1fr !important;
}
.grid-cols-\\[36px_1fr_36px\\] {
    grid-template-columns: 36px 1fr 36px !important;
}
.grid-cols-\\[36px_1fr_auto\\] {
    grid-template-columns: 36px 1fr auto !important;
}
.grid-rows-\\[auto_auto\\] {
    grid-template-rows: auto auto !important;
}
.flex-row {
    flex-direction: row !important;
}
.flex-col {
    flex-direction: column !important;
}
.flex-col-reverse {
    flex-direction: column-reverse !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.items-start {
    align-items: flex-start !important;
}
.items-end {
    align-items: flex-end !important;
}
.items-center {
    align-items: center !important;
}
.items-stretch {
    align-items: stretch !important;
}
.justify-start {
    justify-content: flex-start !important;
}
.justify-end {
    justify-content: flex-end !important;
}
.justify-center {
    justify-content: center !important;
}
.justify-between {
    justify-content: space-between !important;
}
.justify-evenly {
    justify-content: space-evenly !important;
}
.justify-items-start {
    justify-items: start !important;
}
.gap-0 {
    gap: 0px !important;
}
.gap-0\\.5 {
    gap: 0.125rem !important;
}
.gap-1 {
    gap: 0.25rem !important;
}
.gap-1\\.5 {
    gap: 0.375rem !important;
}
.gap-16 {
    gap: 4rem !important;
}
.gap-2 {
    gap: 0.5rem !important;
}
.gap-2\\.5 {
    gap: 0.625rem !important;
}
.gap-20 {
    gap: 5rem !important;
}
.gap-3 {
    gap: 0.75rem !important;
}
.gap-4 {
    gap: 1rem !important;
}
.gap-5 {
    gap: 1.25rem !important;
}
.gap-6 {
    gap: 1.5rem !important;
}
.gap-8 {
    gap: 2rem !important;
}
.gap-\\[3px\\] {
    gap: 3px !important;
}
.gap-x-2 {
    column-gap: 0.5rem !important;
}
.gap-x-3 {
    column-gap: 0.75rem !important;
}
.gap-x-4 {
    column-gap: 1rem !important;
}
.gap-y-0\\.5 {
    row-gap: 0.125rem !important;
}
.gap-y-1 {
    row-gap: 0.25rem !important;
}
.gap-y-3 {
    row-gap: 0.75rem !important;
}
.-space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(-0.25rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(-0.5rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.-space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(-0.75rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.375rem * var(--tw-space-y-reverse)) !important;
}
.space-y-16 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(4rem * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0 !important;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse)) !important;
}
.divide-\\[\\#F0F2F5\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1 !important;
    border-color: rgb(240 242 245 / var(--tw-divide-opacity, 1)) !important;
}
.divide-\\[\\#F2F4F7\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1 !important;
    border-color: rgb(242 244 247 / var(--tw-divide-opacity, 1)) !important;
}
.divide-neutral-100 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1 !important;
    border-color: rgb(245 245 245 / var(--tw-divide-opacity, 1)) !important;
}
.divide-neutral-200 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1 !important;
    border-color: rgb(229 229 229 / var(--tw-divide-opacity, 1)) !important;
}
.self-start {
    align-self: flex-start !important;
}
.self-center {
    align-self: center !important;
}
.self-stretch {
    align-self: stretch !important;
}
.justify-self-end {
    justify-self: end !important;
}
.overflow-auto {
    overflow: auto !important;
}
.overflow-hidden {
    overflow: hidden !important;
}
.overflow-visible {
    overflow: visible !important;
}
.overflow-scroll {
    overflow: scroll !important;
}
.overflow-x-auto {
    overflow-x: auto !important;
}
.overflow-y-auto {
    overflow-y: auto !important;
}
.overflow-x-hidden {
    overflow-x: hidden !important;
}
.overflow-y-visible {
    overflow-y: visible !important;
}
.overscroll-y-contain {
    overscroll-behavior-y: contain !important;
}
.scroll-smooth {
    scroll-behavior: smooth !important;
}
.truncate {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}
.text-ellipsis {
    text-overflow: ellipsis !important;
}
.whitespace-nowrap {
    white-space: nowrap !important;
}
.whitespace-pre-line {
    white-space: pre-line !important;
}
.whitespace-pre-wrap {
    white-space: pre-wrap !important;
}
.text-wrap {
    text-wrap: wrap !important;
}
.text-balance {
    text-wrap: balance !important;
}
.break-words {
    overflow-wrap: break-word !important;
}
.break-all {
    word-break: break-all !important;
}
.\\!rounded-none {
    border-radius: 0px !important;
}
.rounded {
    border-radius: 0.25rem !important;
}
.rounded-2xl {
    border-radius: 1rem !important;
}
.rounded-3xl {
    border-radius: 1.5rem !important;
}
.rounded-\\[10px\\] {
    border-radius: 10px !important;
}
.rounded-\\[12px\\] {
    border-radius: 12px !important;
}
.rounded-\\[16px\\] {
    border-radius: 16px !important;
}
.rounded-\\[20px\\] {
    border-radius: 20px !important;
}
.rounded-\\[24px\\] {
    border-radius: 24px !important;
}
.rounded-\\[2px\\] {
    border-radius: 2px !important;
}
.rounded-\\[3px\\] {
    border-radius: 3px !important;
}
.rounded-\\[40px\\] {
    border-radius: 40px !important;
}
.rounded-\\[4px\\] {
    border-radius: 4px !important;
}
.rounded-\\[5px\\] {
    border-radius: 5px !important;
}
.rounded-\\[6px\\] {
    border-radius: 6px !important;
}
.rounded-\\[80px\\] {
    border-radius: 80px !important;
}
.rounded-\\[8px\\] {
    border-radius: 8px !important;
}
.rounded-\\[inherit\\] {
    border-radius: inherit !important;
}
.rounded-full {
    border-radius: 9999px !important;
}
.rounded-lg {
    border-radius: 0.5rem !important;
}
.rounded-md {
    border-radius: 0.375rem !important;
}
.rounded-none {
    border-radius: 0px !important;
}
.rounded-sm {
    border-radius: 2px !important;
}
.rounded-xl {
    border-radius: 0.75rem !important;
}
.rounded-t-2xl {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
}
.rounded-t-3xl {
    border-top-left-radius: 1.5rem !important;
    border-top-right-radius: 1.5rem !important;
}
.rounded-t-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
}
.rounded-bl-lg {
    border-bottom-left-radius: 0.5rem !important;
}
.rounded-bl-md {
    border-bottom-left-radius: 0.375rem !important;
}
.rounded-bl-sm {
    border-bottom-left-radius: 2px !important;
}
.rounded-bl-xl {
    border-bottom-left-radius: 0.75rem !important;
}
.rounded-br-md {
    border-bottom-right-radius: 0.375rem !important;
}
.rounded-br-sm {
    border-bottom-right-radius: 2px !important;
}
.rounded-tl-lg {
    border-top-left-radius: 0.5rem !important;
}
.rounded-tl-sm {
    border-top-left-radius: 2px !important;
}
.rounded-tl-xl {
    border-top-left-radius: 0.75rem !important;
}
.rounded-tr-lg {
    border-top-right-radius: 0.5rem !important;
}
.border {
    border-width: 1px !important;
}
.border-0 {
    border-width: 0px !important;
}
.border-2 {
    border-width: 2px !important;
}
.border-\\[0\\.5px\\] {
    border-width: 0.5px !important;
}
.border-\\[1\\.5px\\] {
    border-width: 1.5px !important;
}
.border-\\[1px\\] {
    border-width: 1px !important;
}
.border-\\[2px\\] {
    border-width: 2px !important;
}
.border-y {
    border-top-width: 1px !important;
    border-bottom-width: 1px !important;
}
.border-b {
    border-bottom-width: 1px !important;
}
.border-b-0 {
    border-bottom-width: 0px !important;
}
.border-b-2 {
    border-bottom-width: 2px !important;
}
.border-b-4 {
    border-bottom-width: 4px !important;
}
.border-b-\\[1\\.5px\\] {
    border-bottom-width: 1.5px !important;
}
.border-b-\\[1px\\] {
    border-bottom-width: 1px !important;
}
.border-l {
    border-left-width: 1px !important;
}
.border-l-4 {
    border-left-width: 4px !important;
}
.border-r {
    border-right-width: 1px !important;
}
.border-r-\\[1px\\] {
    border-right-width: 1px !important;
}
.border-t {
    border-top-width: 1px !important;
}
.border-t-2 {
    border-top-width: 2px !important;
}
.border-dashed {
    border-style: dashed !important;
}
.border-dotted {
    border-style: dotted !important;
}
.border-\\[\\#0000001A\\] {
    border-color: #0000001A !important;
}
.border-\\[\\#1637E1\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(22 55 225 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#1671D9\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(22 113 217 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#2563EB\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#2746EB40\\] {
    border-color: #2746EB40 !important;
}
.border-\\[\\#2746EB\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(39 70 235 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#3D89DF\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(61 137 223 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#475367\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(71 83 103 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#6CE9A6\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(108 233 166 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#7C3AED\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(124 58 237 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#BFDBFE\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(191 219 254 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#C6DDF7\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(198 221 247 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#D0D5DD\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(208 213 221 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#D1D5DB\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#D4D4D4\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(212 212 212 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#E4E7EC\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F0F2F5\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(240 242 245 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F2F4F7\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(242 244 247 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#FEC84B\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(254 200 75 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#d0d5dd\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(208 213 221 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#e4e7ec\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#e9eaeb\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(233 234 235 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#eaecf1\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(234 236 241 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[--color-border\\] {
    border-color: var(--color-border) !important;
}
.border-black\\/5 {
    border-color: rgb(0 0 0 / 0.05) !important;
}
.border-blue-200 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(191 219 254 / var(--tw-border-opacity, 1)) !important;
}
.border-blue-600 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}
.border-blue-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(29 78 216 / var(--tw-border-opacity, 1)) !important;
}
.border-blue-800 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(30 64 175 / var(--tw-border-opacity, 1)) !important;
}
.border-current {
    border-color: currentColor !important;
}
.border-gray-100 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1)) !important;
}
.border-gray-200 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}
.border-gray-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
}
.border-green-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(21 128 61 / var(--tw-border-opacity, 1)) !important;
}
.border-neutral-200 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(229 229 229 / var(--tw-border-opacity, 1)) !important;
}
.border-neutral-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(212 212 212 / var(--tw-border-opacity, 1)) !important;
}
.border-neutral-400 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(163 163 163 / var(--tw-border-opacity, 1)) !important;
}
.border-red-500 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.border-red-600 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1)) !important;
}
.border-slate-100 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1)) !important;
}
.border-slate-200 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1)) !important;
}
.border-slate-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1)) !important;
}
.border-transparent {
    border-color: transparent !important;
}
.border-violet-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(109 40 217 / var(--tw-border-opacity, 1)) !important;
}
.border-white {
    --tw-border-opacity: 1 !important;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-white\\/20 {
    border-color: rgb(255 255 255 / 0.2) !important;
}
.border-white\\/40 {
    border-color: rgb(255 255 255 / 0.4) !important;
}
.border-yellow-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(161 98 7 / var(--tw-border-opacity, 1)) !important;
}
.border-l-transparent {
    border-left-color: transparent !important;
}
.border-t-transparent {
    border-top-color: transparent !important;
}
.bg-\\[\\#040915\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(4 9 21 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0B0E14\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(11 14 20 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0D5EBA\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(13 94 186 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#101928\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(16 25 40 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#12B76A\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#2563EB\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#2746EB\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(39 70 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#60A5FA\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#64748B\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#B8D4F8\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(184 212 248 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#D0D5DD\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(208 213 221 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#D1FAE5\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#D4D4D4\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(212 212 212 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#DBEAFE\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E3EFFC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(227 239 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E4E7EC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E7F6EC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(231 246 236 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E8F0FE\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(232 240 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E8F4FC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(232 244 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#ECFDF3\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#EDE9FE\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#EFF4FF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 244 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#EFF6FF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F0F2F5\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F0F4FF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 244 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F2F4F7\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F3E8FF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F5F5F5\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F7F9FC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(247 249 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F8FAFC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F8FBFF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(248 251 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F9FAFB\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FAFAFA\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FAFBFC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 251 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FBEAE9\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(251 234 233 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FCFCFD\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(252 252 253 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FEF6E7\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(254 246 231 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFFAEB\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFFFFF\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#e4e7ec\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#e7eef7\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(231 238 247 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#e8f5ec\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(232 245 236 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#edebf7\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(237 235 247 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#f0f2f5\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#f6f4e0\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(246 244 224 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#f7f9fc\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(247 249 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#fff\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[--color-bg\\] {
    background-color: var(--color-bg) !important;
}
.bg-amber-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-black {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.bg-black\\/10 {
    background-color: rgb(0 0 0 / 0.1) !important;
}
.bg-black\\/30 {
    background-color: rgb(0 0 0 / 0.3) !important;
}
.bg-black\\/40 {
    background-color: rgb(0 0 0 / 0.4) !important;
}
.bg-black\\/50 {
    background-color: rgb(0 0 0 / 0.5) !important;
}
.bg-black\\/60 {
    background-color: rgb(0 0 0 / 0.6) !important;
}
.bg-blue-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-blue-200 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-blue-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-blue-500 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}
.bg-blue-600 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-cyan-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-emerald-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1)) !important;
}
.bg-gray-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}
.bg-gray-200 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-gray-400 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1)) !important;
}
.bg-gray-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-500 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}
.bg-indigo-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-lime-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(247 254 231 / var(--tw-bg-opacity, 1)) !important;
}
.bg-neutral-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}
.bg-neutral-200 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1)) !important;
}
.bg-neutral-300 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(212 212 212 / var(--tw-bg-opacity, 1)) !important;
}
.bg-neutral-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.bg-orange-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1)) !important;
}
.bg-purple-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-500 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1)) !important;
}
.bg-slate-200 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1)) !important;
}
.bg-slate-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-slate-900 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1)) !important;
}
.bg-stone-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 245 244 / var(--tw-bg-opacity, 1)) !important;
}
.bg-transparent {
    background-color: transparent !important;
}
.bg-violet-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-white {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-white\\/10 {
    background-color: rgb(255 255 255 / 0.1) !important;
}
.bg-white\\/20 {
    background-color: rgb(255 255 255 / 0.2) !important;
}
.bg-yellow-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1)) !important;
}
.bg-yellow-500 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}
.bg-opacity-50 {
    --tw-bg-opacity: 0.5 !important;
}
.bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--tw-gradient-stops)) !important;
}
.from-\\[\\#2746EB\\] {
    --tw-gradient-from: #2746EB var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(39 70 235 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[\\#2746EB\\]\\/20 {
    --tw-gradient-from: rgb(39 70 235 / 0.2) var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(39 70 235 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[\\#4F46E5\\] {
    --tw-gradient-from: #4F46E5 var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[\\#f8faff\\] {
    --tw-gradient-from: #f8faff var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(248 250 255 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-slate-200 {
    --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-transparent {
    --tw-gradient-from: transparent var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-white {
    --tw-gradient-from: #fff var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.via-\\[\\#2746EB\\] {
    --tw-gradient-to: rgb(39 70 235 / 0)  var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), #2746EB var(--tw-gradient-via-position), var(--tw-gradient-to) !important;
}
.via-\\[\\#f0f4ff\\] {
    --tw-gradient-to: rgb(240 244 255 / 0)  var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), #f0f4ff var(--tw-gradient-via-position), var(--tw-gradient-to) !important;
}
.via-transparent {
    --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to) !important;
}
.via-white\\/90 {
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.9) var(--tw-gradient-via-position), var(--tw-gradient-to) !important;
}
.to-\\[\\#1E40AF\\] {
    --tw-gradient-to: #1E40AF var(--tw-gradient-to-position) !important;
}
.to-\\[\\#FAFBFC\\] {
    --tw-gradient-to: #FAFBFC var(--tw-gradient-to-position) !important;
}
.to-\\[\\#FAFBFC\\]\\/80 {
    --tw-gradient-to: rgb(250 251 252 / 0.8) var(--tw-gradient-to-position) !important;
}
.to-indigo-300\\/30 {
    --tw-gradient-to: rgb(165 180 252 / 0.3) var(--tw-gradient-to-position) !important;
}
.to-indigo-400 {
    --tw-gradient-to: #818cf8 var(--tw-gradient-to-position) !important;
}
.to-slate-300 {
    --tw-gradient-to: #cbd5e1 var(--tw-gradient-to-position) !important;
}
.to-slate-50 {
    --tw-gradient-to: #f8fafc var(--tw-gradient-to-position) !important;
}
.to-transparent {
    --tw-gradient-to: transparent var(--tw-gradient-to-position) !important;
}
.fill-current {
    fill: currentColor !important;
}
.fill-slate-700 {
    fill: #334155 !important;
}
.object-contain {
    object-fit: contain !important;
}
.object-cover {
    object-fit: cover !important;
}
.object-top {
    object-position: top !important;
}
.p-0 {
    padding: 0px !important;
}
.p-0\\.5 {
    padding: 0.125rem !important;
}
.p-1 {
    padding: 0.25rem !important;
}
.p-1\\.5 {
    padding: 0.375rem !important;
}
.p-10 {
    padding: 2.5rem !important;
}
.p-12 {
    padding: 3rem !important;
}
.p-2 {
    padding: 0.5rem !important;
}
.p-2\\.5 {
    padding: 0.625rem !important;
}
.p-3 {
    padding: 0.75rem !important;
}
.p-3\\.5 {
    padding: 0.875rem !important;
}
.p-4 {
    padding: 1rem !important;
}
.p-5 {
    padding: 1.25rem !important;
}
.p-6 {
    padding: 1.5rem !important;
}
.p-8 {
    padding: 2rem !important;
}
.p-\\[3px\\] {
    padding: 3px !important;
}
.p-px {
    padding: 1px !important;
}
.px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
.px-0\\.5 {
    padding-left: 0.125rem !important;
    padding-right: 0.125rem !important;
}
.px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
}
.px-1\\.5 {
    padding-left: 0.375rem !important;
    padding-right: 0.375rem !important;
}
.px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
}
.px-12 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
}
.px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.px-2\\.5 {
    padding-left: 0.625rem !important;
    padding-right: 0.625rem !important;
}
.px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}
.px-3\\.5 {
    padding-left: 0.875rem !important;
    padding-right: 0.875rem !important;
}
.px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
}
.px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}
.px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}
.py-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.py-0\\.5 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
}
.py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.py-1\\.5 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}
.py-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
}
.py-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
}
.py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.py-2\\.5 {
    padding-top: 0.625rem !important;
    padding-bottom: 0.625rem !important;
}
.py-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
}
.py-24 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
}
.py-28 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
}
.py-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}
.py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.py-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
}
.py-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
}
.py-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
}
.py-\\[0\\.5px\\] {
    padding-top: 0.5px !important;
    padding-bottom: 0.5px !important;
}
.py-\\[10px\\] {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
.py-\\[1px\\] {
    padding-top: 1px !important;
    padding-bottom: 1px !important;
}
.py-\\[3px\\] {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
}
.py-\\[5\\.5px\\] {
    padding-top: 5.5px !important;
    padding-bottom: 5.5px !important;
}
.py-\\[7\\.5px\\] {
    padding-top: 7.5px !important;
    padding-bottom: 7.5px !important;
}
.pb-1 {
    padding-bottom: 0.25rem !important;
}
.pb-10 {
    padding-bottom: 2.5rem !important;
}
.pb-16 {
    padding-bottom: 4rem !important;
}
.pb-2 {
    padding-bottom: 0.5rem !important;
}
.pb-20 {
    padding-bottom: 5rem !important;
}
.pb-24 {
    padding-bottom: 6rem !important;
}
.pb-3 {
    padding-bottom: 0.75rem !important;
}
.pb-4 {
    padding-bottom: 1rem !important;
}
.pb-5 {
    padding-bottom: 1.25rem !important;
}
.pb-6 {
    padding-bottom: 1.5rem !important;
}
.pb-\\[60px\\] {
    padding-bottom: 60px !important;
}
.pl-1 {
    padding-left: 0.25rem !important;
}
.pl-10 {
    padding-left: 2.5rem !important;
}
.pl-2 {
    padding-left: 0.5rem !important;
}
.pl-24 {
    padding-left: 6rem !important;
}
.pl-3 {
    padding-left: 0.75rem !important;
}
.pl-4 {
    padding-left: 1rem !important;
}
.pl-5 {
    padding-left: 1.25rem !important;
}
.pl-8 {
    padding-left: 2rem !important;
}
.pl-\\[52px\\] {
    padding-left: 52px !important;
}
.pr-0\\.5 {
    padding-right: 0.125rem !important;
}
.pr-12 {
    padding-right: 3rem !important;
}
.pr-2 {
    padding-right: 0.5rem !important;
}
.pr-2\\.5 {
    padding-right: 0.625rem !important;
}
.pr-3 {
    padding-right: 0.75rem !important;
}
.pr-4 {
    padding-right: 1rem !important;
}
.pr-5 {
    padding-right: 1.25rem !important;
}
.pr-8 {
    padding-right: 2rem !important;
}
.pt-0 {
    padding-top: 0px !important;
}
.pt-0\\.5 {
    padding-top: 0.125rem !important;
}
.pt-1 {
    padding-top: 0.25rem !important;
}
.pt-10 {
    padding-top: 2.5rem !important;
}
.pt-16 {
    padding-top: 4rem !important;
}
.pt-2 {
    padding-top: 0.5rem !important;
}
.pt-3 {
    padding-top: 0.75rem !important;
}
.pt-4 {
    padding-top: 1rem !important;
}
.pt-5 {
    padding-top: 1.25rem !important;
}
.pt-6 {
    padding-top: 1.5rem !important;
}
.text-left {
    text-align: left !important;
}
.text-center {
    text-align: center !important;
}
.text-right {
    text-align: right !important;
}
.align-top {
    vertical-align: top !important;
}
.align-middle {
    vertical-align: middle !important;
}
.font-\\[\\'DM_Sans\\'\\] {
    font-family: 'DM Sans' !important;
}
.font-mono {
    font-family: JetBrains Mono, Commit Mono, monospace !important;
}
.text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
}
.text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
}
.text-4xl {
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
}
.text-\\[0\\.8rem\\] {
    font-size: 0.8rem !important;
}
.text-\\[0\\.9em\\] {
    font-size: 0.9em !important;
}
.text-\\[10px\\] {
    font-size: 10px !important;
}
.text-\\[11px\\] {
    font-size: 11px !important;
}
.text-\\[12px\\] {
    font-size: 12px !important;
}
.text-\\[13px\\] {
    font-size: 13px !important;
}
.text-\\[14px\\] {
    font-size: 14px !important;
}
.text-\\[15px\\] {
    font-size: 15px !important;
}
.text-\\[15vw\\] {
    font-size: 15vw !important;
}
.text-\\[16px\\] {
    font-size: 16px !important;
}
.text-\\[17px\\] {
    font-size: 17px !important;
}
.text-\\[18px\\] {
    font-size: 18px !important;
}
.text-\\[20px\\] {
    font-size: 20px !important;
}
.text-\\[24px\\] {
    font-size: 24px !important;
}
.text-\\[26px\\] {
    font-size: 26px !important;
}
.text-\\[28px\\] {
    font-size: 28px !important;
}
.text-\\[30px\\] {
    font-size: 30px !important;
}
.text-\\[33px\\] {
    font-size: 33px !important;
}
.text-\\[8px\\] {
    font-size: 8px !important;
}
.text-\\[9px\\] {
    font-size: 9px !important;
}
.text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
}
.text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
}
.text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
}
.text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}
.font-\\[400\\] {
    font-weight: 400 !important;
}
.font-\\[500\\] {
    font-weight: 500 !important;
}
.font-\\[600\\] {
    font-weight: 600 !important;
}
.font-\\[700\\] {
    font-weight: 700 !important;
}
.font-black {
    font-weight: 900 !important;
}
.font-bold {
    font-weight: 700 !important;
}
.font-light {
    font-weight: 300 !important;
}
.font-medium {
    font-weight: 500 !important;
}
.font-normal {
    font-weight: 400 !important;
}
.font-semibold {
    font-weight: 600 !important;
}
.uppercase {
    text-transform: uppercase !important;
}
.capitalize {
    text-transform: capitalize !important;
}
.italic {
    font-style: italic !important;
}
.tabular-nums {
    --tw-numeric-spacing: tabular-nums !important;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.leading-5 {
    line-height: 1.25rem !important;
}
.leading-6 {
    line-height: 1.5rem !important;
}
.leading-7 {
    line-height: 1.75rem !important;
}
.leading-\\[1\\.1\\] {
    line-height: 1.1 !important;
}
.leading-\\[1\\.5\\] {
    line-height: 1.5 !important;
}
.leading-\\[12px\\] {
    line-height: 12px !important;
}
.leading-\\[20px\\] {
    line-height: 20px !important;
}
.leading-none {
    line-height: 1 !important;
}
.leading-normal {
    line-height: 1.5 !important;
}
.leading-relaxed {
    line-height: 1.625 !important;
}
.leading-snug {
    line-height: 1.375 !important;
}
.leading-tight {
    line-height: 1.25 !important;
}
.tracking-\\[-0\\.24px\\] {
    letter-spacing: -0.24px !important;
}
.tracking-\\[1\\.5px\\] {
    letter-spacing: 1.5px !important;
}
.tracking-\\[3px\\] {
    letter-spacing: 3px !important;
}
.tracking-tight {
    letter-spacing: -0.025em !important;
}
.tracking-tighter {
    letter-spacing: -0.05em !important;
}
.tracking-wide {
    letter-spacing: 0.025em !important;
}
.tracking-wider {
    letter-spacing: 0.05em !important;
}
.tracking-widest {
    letter-spacing: 0.1em !important;
}
.text-\\[\\#000\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#027A48\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(2 122 72 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#036B26\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(3 107 38 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#04326B\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(4 50 107 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#04802E\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(4 128 46 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0A0A0A\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(10 10 10 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0F172A\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0a0a0a\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(10 10 10 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#101928\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(16 25 40 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#10B981\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(16 185 129 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#11121A\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(17 18 26 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#11121a\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(17 18 26 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1637E1\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(22 55 225 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1671D9\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(22 113 217 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#181D27\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(24 29 39 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1A1A1A\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(26 26 26 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1D2739\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(29 39 57 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1D4ED8\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1a1a1a\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(26 26 26 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1d2739\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(29 39 57 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#2563EB\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#2746EB\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(39 70 235 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#344054\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#3D89DF\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(61 137 223 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#475367\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(71 83 103 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#475467\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(71 84 103 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#525252\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#6366F1\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(99 102 241 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#667085\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(102 112 133 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#667185\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(102 113 133 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#6B21A8\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(107 33 168 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#6B7280\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#737373\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#865503\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(134 85 3 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#98A2B3\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#9E0A05\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(158 10 5 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#B54708\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(181 71 8 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#BA110B\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(186 17 11 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#CB1A14\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(203 26 20 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#D92D20\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(217 45 32 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#EF4444\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#F2F4F7\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(242 244 247 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#FAFAFA\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(250 250 250 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#FFFFFF\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#fff\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(180 83 9 / var(--tw-text-opacity, 1)) !important;
}
.text-black {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-100 {
    --tw-text-opacity: 1 !important;
    color: rgb(219 234 254 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(30 64 175 / var(--tw-text-opacity, 1)) !important;
}
.text-current {
    color: currentColor !important;
}
.text-cyan-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(21 94 117 / var(--tw-text-opacity, 1)) !important;
}
.text-emerald-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(6 95 70 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-900 {
    --tw-text-opacity: 1 !important;
    color: rgb(17 24 39 / var(--tw-text-opacity, 1)) !important;
}
.text-green-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(21 128 61 / var(--tw-text-opacity, 1)) !important;
}
.text-green-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(22 101 52 / var(--tw-text-opacity, 1)) !important;
}
.text-lime-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(77 124 15 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-300 {
    --tw-text-opacity: 1 !important;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-50 {
    --tw-text-opacity: 1 !important;
    color: rgb(250 250 250 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(64 64 64 / var(--tw-text-opacity, 1)) !important;
}
.text-neutral-900 {
    --tw-text-opacity: 1 !important;
    color: rgb(23 23 23 / var(--tw-text-opacity, 1)) !important;
}
.text-orange-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(154 52 18 / var(--tw-text-opacity, 1)) !important;
}
.text-purple-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 33 168 / var(--tw-text-opacity, 1)) !important;
}
.text-red-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.text-red-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.text-red-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-300 {
    --tw-text-opacity: 1 !important;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(71 85 105 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-900 {
    --tw-text-opacity: 1 !important;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1)) !important;
}
.text-stone-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(68 64 60 / var(--tw-text-opacity, 1)) !important;
}
.text-transparent {
    color: transparent !important;
}
.text-violet-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(109 40 217 / var(--tw-text-opacity, 1)) !important;
}
.text-white {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-white\\/80 {
    color: rgb(255 255 255 / 0.8) !important;
}
.text-white\\/90 {
    color: rgb(255 255 255 / 0.9) !important;
}
.text-yellow-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(250 204 21 / var(--tw-text-opacity, 1)) !important;
}
.text-yellow-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(161 98 7 / var(--tw-text-opacity, 1)) !important;
}
.underline {
    text-decoration-line: underline !important;
}
.decoration-neutral-500 {
    text-decoration-color: #737373 !important;
}
.underline-offset-2 {
    text-underline-offset: 2px !important;
}
.underline-offset-4 {
    text-underline-offset: 4px !important;
}
.placeholder-\\[\\#98A2B3\\]::placeholder {
    --tw-placeholder-opacity: 1 !important;
    color: rgb(152 162 179 / var(--tw-placeholder-opacity, 1)) !important;
}
.opacity-0 {
    opacity: 0 !important;
}
.opacity-100 {
    opacity: 1 !important;
}
.opacity-40 {
    opacity: 0.4 !important;
}
.opacity-5 {
    opacity: 0.05 !important;
}
.opacity-50 {
    opacity: 0.5 !important;
}
.opacity-60 {
    opacity: 0.6 !important;
}
.opacity-70 {
    opacity: 0.7 !important;
}
.opacity-90 {
    opacity: 0.9 !important;
}
.opacity-\\[0\\.02\\] {
    opacity: 0.02 !important;
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
    --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border)) !important;
    --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_3px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.1\\)\\] {
    --tw-shadow: 0 0 0 3px rgba(37,99,235,0.1) !important;
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_3px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.12\\)\\2c 0_1px_6px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.06\\)\\] {
    --tw-shadow: 0 0 0 3px rgba(37,99,235,0.12),0 1px 6px rgba(16,24,40,0.06) !important;
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color), 0 1px 6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 1px 2px rgba(0,0,0,0.08) !important;
    --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_1px_3px_\\#bfdbfe\\2c 0_1px_2px_-1px_\\#bfdbfe\\] {
    --tw-shadow: 0 1px 3px #bfdbfe,0 1px 2px -1px #bfdbfe !important;
    --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_1px_6px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.06\\)\\] {
    --tw-shadow: 0 1px 6px rgba(16,24,40,0.06) !important;
    --tw-shadow-colored: 0 1px 6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_0px_0px_2px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.8\\)\\] {
    --tw-shadow: 0px 0px 0px 2px rgba(37,99,235,0.8) !important;
    --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
    --tw-shadow: 0px 1px 2px 0 rgba(0,0,0,0.05) !important;
    --tw-shadow-colored: 0px 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
    --tw-shadow: 0px 1px 2px 0 rgba(0,0,0,0.06) !important;
    --tw-shadow-colored: 0px 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_1px_3px_0_\\#bfdbfe\\2c 0px_1px_2px_-1px_\\#bfdbfe\\] {
    --tw-shadow: 0px 1px 3px 0 #bfdbfe,0px 1px 2px -1px #bfdbfe !important;
    --tw-shadow-colored: 0px 1px 3px 0 var(--tw-shadow-color), 0px 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_1px_3px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c 0px_1px_2px_-1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0px 1px 3px 0 rgba(0,0,0,0.1),0px 1px 2px -1px rgba(0,0,0,0.1) !important;
    --tw-shadow-colored: 0px 1px 3px 0 var(--tw-shadow-color), 0px 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_4px_6px_-1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c 0px_2px_4px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0px 4px 6px -1px rgba(0,0,0,0.1),0px 2px 4px -2px rgba(0,0,0,0.1) !important;
    --tw-shadow-colored: 0px 4px 6px -1px var(--tw-shadow-color), 0px 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[\\#2746EB\\]\\/20 {
    --tw-shadow-color: rgb(39 70 235 / 0.2) !important;
    --tw-shadow: var(--tw-shadow-colored) !important;
}
.outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline {
    outline-style: solid !important;
}
.ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-0 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-4 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-\\[\\#DBEAFE\\] {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1)) !important;
}
.ring-\\[\\#F9FAFB\\] {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: rgb(249 250 251 / var(--tw-ring-opacity, 1)) !important;
}
.blur {
    --tw-blur: blur(8px) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.blur-2xl {
    --tw-blur: blur(40px) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow {
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06)) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-filter {
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[background-color\\2c box-shadow\\] {
    transition-property: background-color,box-shadow !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[color\\2c box-shadow\\] {
    transition-property: color,box-shadow !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[left\\2c right\\2c width\\] {
    transition-property: left,right,width !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[margin\\2c opacity\\] {
    transition-property: margin,opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[width\\2c height\\2c padding\\] {
    transition-property: width,height,padding !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-\\[width\\] {
    transition-property: width !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-all {
    transition-property: all !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-none {
    transition-property: none !important;
}
.transition-opacity {
    transition-property: opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-shadow {
    transition-property: box-shadow !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-transform {
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.duration-1000 {
    transition-duration: 1000ms !important;
}
.duration-200 {
    transition-duration: 200ms !important;
}
.duration-300 {
    transition-duration: 300ms !important;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.ease-linear {
    transition-timing-function: linear !important;
}
@keyframes enter {
    from {
        opacity: var(--tw-enter-opacity, 1);
        transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
    }
}
@keyframes exit {
    to {
        opacity: var(--tw-exit-opacity, 1);
        transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
    }
}
.animate-in {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.fade-in-0 {
    --tw-enter-opacity: 0 !important;
}
.zoom-in-95 {
    --tw-enter-scale: .95 !important;
}
.duration-1000 {
    animation-duration: 1000ms !important;
}
.duration-200 {
    animation-duration: 200ms !important;
}
.duration-300 {
    animation-duration: 300ms !important;
}
.ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.ease-linear {
    animation-timing-function: linear !important;
}
.running {
    animation-play-state: running !important;
}
.paused {
    animation-play-state: paused !important;
}
@keyframes dockie-loader-bounce {
    0%,
    100% {
      transform: scale(0.92);
      opacity: 0.72;
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
  }
.dockie-loader-bounce {
    animation: dockie-loader-bounce 2.4s ease-in-out infinite !important;
  }
.\\[-webkit-overflow-scrolling\\:touch\\] {
    -webkit-overflow-scrolling: touch !important;
}

/* optional shadcn imports */


html {
    scroll-behavior: smooth;
    padding: 0;
    margin: 0;
  }

.hero-section {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 45vh;
    height: auto;
    background-color: #00000066;
    object-fit: contain;
}

@media (min-width: 480px) {
    .hero-section {
        min-height: 50vh;
    }
}

@media (min-width: 640px) {
    .hero-section {
        min-height: 55vh;
    }
}

@media (min-width: 1024px) {
    .hero-section {
        height: 71vh;
        background-size: center;
        background-position: 50% 60%;
    }
}

.bg-sponsor {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 100vw;
    height: auto;
    object-fit: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

@media (min-width: 1024px) {
    .bg-sponsor {
        background-position: 30% 50%;
        background-size: contain;
    }
}

.bg-ai {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    width: 100%;
    height: auto;
    object-fit: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

@media (min-width: 1024px) {
    .bg-ai {
        background-position: 30% 50%;
        background-size: contain;
    }
}

.search-component {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background-color: #ffffff;
    border: 1px solid #FFFFFF00;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #0A0919,
                0 2px 3px #FFFFFF00;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
}

@media (min-width: 480px) {
    .search-component {
        padding: 5px 10px;
        border-radius: 12px;
    }
}

@media (min-width: 640px) {
    .search-component {
        padding: 5px 15px;
    }
}
  
  .search-icon {
    /* Styling for your icon */
    margin-right: 10px;
    width: 28.19px; /* Adjust size */
    height: 28.19px; /* Adjust size */
    background: linear-gradient(to top, #0A05F854, #fff); /* Example gradient for the icon */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center; 
    animation: slideGradient 5s linear infinite;

 }
 @keyframes slideGradient {
    0% { background-position: 0% 0%; }
    100% { background-position: 100% 0%; }
  }
  .search-input {
    flex-grow: 1;
    border: none;
    outline: none;
    background: transparent;
    padding: 2px 0;
    font-size: 11px;
    font-weight: 400;
    color: #313233;
    min-width: 0;
  }

  .search-input:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }

  @media (min-width: 480px) {
    .search-input {
        font-size: 12px;
        padding: 10px 0;
    }
  }

  @media (min-width: 640px) {
    .search-input {
        font-size: 14px;
        padding: 12px 0;
    }
  }
  
  .chat-button {
    background-color: #000000;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
    margin-left: 6px;
    white-space: nowrap;
    flex-shrink: 0;
    transition: all 0.2s ease;
    min-height: 32px;
  }

  .chat-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .chat-button:hover:not(:disabled) {
    background-color: #333333;
    transform: translateY(-1px);
  }

  @media (min-width: 480px) {
    .chat-button {
        padding: 7px 12px;
        font-size: 13px;
        border-radius: 24px;
        min-height: 36px;
    }
  }

  @media (min-width: 640px) {
    .chat-button {
        padding: 10px 20px;
        font-size: 16px;
        margin-left: 15px;
        border-radius: 28px;
        min-height: 40px;
    }
  }

/* Additional mobile responsive utilities */
@media (max-width: 639px) {
  .mobile-hidden {
    display: none !important;
  }
  
  .mobile-full-width {
    width: 100% !important;
  }
  
  .mobile-text-sm {
    font-size: 0.875rem !important;
  }
  
  .mobile-p-2 {
    padding: 0.5rem !important;
  }
  
  .mobile-gap-2 {
    gap: 0.5rem !important;
  }
}

/* Ensure proper touch targets on mobile */
@media (max-width: 639px) {
  button, .clickable {
    min-height: 44px;
    min-width: 44px;
  }
  
  input, textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

/* Responsive container utilities */
.container-responsive {
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 640px) {
  .container-responsive {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container-responsive {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

/* Global input styling */
input[type="text"],
input[type="email"],
input[type="password"],
input[type="tel"],
input[type="number"],
textarea {
  width: 100%;
  height: 48px;
  /* padding: 12px 16px; */
  /* border: 1px solid #D1D5DB; */
  border-radius: 12px;
  font-size: 13px;
  font-family: 'DM Sans', sans-serif;
  outline: none;
  /* background-color: #FFFFFF; */
  color: #374151;
  transition: border-color 0.2s ease;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="number"]:focus,
textarea:focus {
  border-color: #2563EB;
  /* box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); */
}

textarea {
  height: auto;
  min-height: 48px;
  resize: vertical;
}

/* Google button styling */
.google-button {
  width: 100%;
  height: 48px;
  background-color: #FFFFFF;
  border: 1px solid #D1D5DB;
  border-radius: 12px;
  color: #374151;
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.google-button:hover {
  background-color: #F9FAFB;
}

/* Sidebar scrollbar — thin, neutral track */
.dockie-sidebar-scroll {
  scrollbar-width: thin;
  scrollbar-color: #d4d4d4 transparent;
}

.dockie-sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}

.dockie-sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.dockie-sidebar-scroll::-webkit-scrollbar-thumb {
  background-color: #d4d4d4;
  border-radius: 999px;
}

.dockie-sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #a3a3a3;
}

/* Live voice chat wave animations */
@keyframes voice-wave-drift-left {
  0%,
  100% {
    transform: translateY(3px) scaleY(0.92);
  }
  35% {
    transform: translateY(-5px) scaleY(1.04);
  }
  70% {
    transform: translateY(-1px) scaleY(0.98);
  }
}

@keyframes voice-wave-drift-mid {
  0%,
  100% {
    transform: translateY(1px) scaleY(0.9);
  }
  45% {
    transform: translateY(-7px) scaleY(1.08);
  }
  80% {
    transform: translateY(-2px) scaleY(1);
  }
}

@keyframes voice-wave-drift-right {
  0%,
  100% {
    transform: translateY(2px) scaleY(0.94);
  }
  40% {
    transform: translateY(-6px) scaleY(1.06);
  }
  75% {
    transform: translateY(0) scaleY(0.97);
  }
}

@keyframes voice-wave-subtle-drift {
  0%,
  100% {
    transform: translateY(1px) scaleY(0.85);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-2px) scaleY(1);
    opacity: 1;
  }
}

@keyframes voice-note-dot-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.35;
  }
  50% {
    transform: scale(1.35);
    opacity: 1;
  }
}

@keyframes voice-note-bar-pulse {
  0%,
  100% {
    transform: scaleY(0.45);
    opacity: 0.5;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}

.voice-chat-wave-svg {
  transform-origin: center bottom;
  will-change: transform;
}

.voice-chat-waves-mask {
  mask-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.35) 6%,
    #000 14%,
    #000 86%,
    rgba(0, 0, 0, 0.35) 94%,
    transparent 100%
  );
}

.voice-chat-wave-svg--back {
  animation: voice-wave-sway-back 2.6s ease-in-out infinite;
}

.voice-chat-wave-svg--mid {
  animation: voice-wave-sway-mid 2.2s ease-in-out infinite;
}

.voice-chat-wave-svg--front {
  animation: voice-wave-sway-front 2s ease-in-out infinite;
}

.voice-chat-wave-svg--subtle {
  animation: voice-wave-sway-subtle 2.4s ease-in-out infinite;
}

@keyframes voice-wave-sway-back {
  0%,
  100% {
    transform: translateX(0) scaleY(0.96);
  }
  50% {
    transform: translateX(-0.8%) scaleY(1.02);
  }
}

@keyframes voice-wave-sway-mid {
  0%,
  100% {
    transform: translateX(0) scaleY(0.94);
  }
  50% {
    transform: translateX(0.8%) scaleY(1.04);
  }
}

@keyframes voice-wave-sway-front {
  0%,
  100% {
    transform: translateX(0) scaleY(0.95);
  }
  50% {
    transform: translateX(-0.5%) scaleY(1.03);
  }
}

@keyframes voice-wave-sway-subtle {
  0%,
  100% {
    transform: translateX(0) scaleY(0.92);
    opacity: 0.65;
  }
  50% {
    transform: translateX(0.5%) scaleY(0.98);
    opacity: 0.9;
  }
}

.voice-chat-wave-layer {
  height: 14px;
  border-radius: 999px 999px 0 0;
  transform-origin: bottom center;
  will-change: transform;
}

.voice-chat-wave-layer--back {
  background: linear-gradient(180deg, #bfdbfe 0%, #93c5fd 100%);
  animation: voice-wave-drift-left 2.4s ease-in-out infinite;
}

.voice-chat-wave-layer--mid {
  background: linear-gradient(180deg, #60a5fa 0%, #3b82f6 100%);
  animation: voice-wave-drift-mid 2s ease-in-out infinite;
}

.voice-chat-wave-layer--front {
  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);
  animation: voice-wave-drift-right 2.2s ease-in-out infinite;
}

.voice-chat-wave-layer--subtle {
  background: linear-gradient(180deg, #dbeafe 0%, #bfdbfe 100%);
  animation: voice-wave-subtle-drift 2s ease-in-out infinite;
}

.voice-flow-wave-layer {
  transform-box: fill-box;
  transform-origin: center bottom;
  will-change: transform;
}

.voice-flow-wave-layer--back {
  animation: voice-flow-wave-back 4.8s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

.voice-flow-wave-layer--middle {
  animation: voice-flow-wave-middle 4.1s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

.voice-flow-wave-layer--front {
  animation: voice-flow-wave-front 3.6s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

@keyframes voice-flow-wave-back {
  0%,
  100% {
    transform: translateX(-0.5%) scaleX(1.02) scaleY(0.92);
  }
  34% {
    transform: translateX(0.3%) scaleX(1.02) scaleY(1.07);
  }
  68% {
    transform: translateX(-0.1%) scaleX(1.02) scaleY(0.98);
  }
}

@keyframes voice-flow-wave-middle {
  0%,
  100% {
    transform: translateX(0.4%) scaleX(1.02) scaleY(0.96);
  }
  38% {
    transform: translateX(-0.3%) scaleX(1.02) scaleY(1.08);
  }
  72% {
    transform: translateX(0.1%) scaleX(1.02) scaleY(0.9);
  }
}

@keyframes voice-flow-wave-front {
  0%,
  100% {
    transform: translateX(-0.2%) scaleX(1.02) scaleY(0.9);
  }
  42% {
    transform: translateX(0.25%) scaleX(1.02) scaleY(1.04);
  }
  76% {
    transform: translateX(-0.1%) scaleX(1.02) scaleY(0.96);
  }
}

.voice-note-dot {
  animation: voice-note-dot-pulse 1s ease-in-out infinite;
}

.voice-note-bar {
  transform-origin: bottom center;
  animation: voice-note-bar-pulse 0.9s ease-in-out infinite;
}

.marker\\:text-\\[\\#98A2B3\\] *::marker {
    color: rgb(152 162 179 ) !important;
}

.marker\\:text-\\[\\#98A2B3\\]::marker {
    color: rgb(152 162 179 ) !important;
}

.selection\\:bg-sky-500\\/20 *::selection {
    background-color: rgb(14 165 233 / 0.2) !important;
}

.selection\\:text-sky-900 *::selection {
    --tw-text-opacity: 1 !important;
    color: rgb(12 74 110 / var(--tw-text-opacity, 1)) !important;
}

.selection\\:bg-sky-500\\/20::selection {
    background-color: rgb(14 165 233 / 0.2) !important;
}

.selection\\:text-sky-900::selection {
    --tw-text-opacity: 1 !important;
    color: rgb(12 74 110 / var(--tw-text-opacity, 1)) !important;
}

.file\\:inline-flex::file-selector-button {
    display: inline-flex !important;
}

.file\\:h-7::file-selector-button {
    height: 1.75rem !important;
}

.file\\:border-0::file-selector-button {
    border-width: 0px !important;
}

.file\\:bg-transparent::file-selector-button {
    background-color: transparent !important;
}

.file\\:text-sm::file-selector-button {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}

.file\\:font-medium::file-selector-button {
    font-weight: 500 !important;
}

.placeholder\\:text-\\[\\#9CA3AF\\]::placeholder {
    --tw-text-opacity: 1 !important;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}

.placeholder\\:text-neutral-500::placeholder {
    --tw-text-opacity: 1 !important;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1)) !important;
}

.after\\:absolute::after {
    content: var(--tw-content) !important;
    position: absolute !important;
}

.after\\:-inset-2::after {
    content: var(--tw-content) !important;
    inset: -0.5rem !important;
}

.after\\:inset-y-0::after {
    content: var(--tw-content) !important;
    top: 0px !important;
    bottom: 0px !important;
}

.after\\:left-1\\/2::after {
    content: var(--tw-content) !important;
    left: 50% !important;
}

.after\\:w-1::after {
    content: var(--tw-content) !important;
    width: 0.25rem !important;
}

.after\\:w-\\[2px\\]::after {
    content: var(--tw-content) !important;
    width: 2px !important;
}

.after\\:-translate-x-1\\/2::after {
    content: var(--tw-content) !important;
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.first\\:mt-0:first-child {
    margin-top: 0px !important;
}

.first\\:rounded-l-md:first-child {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}

.first\\:border-l:first-child {
    border-left-width: 1px !important;
}

.last\\:mb-0:last-child {
    margin-bottom: 0px !important;
}

.last\\:rounded-r-md:last-child {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.last\\:border-b-0:last-child {
    border-bottom-width: 0px !important;
}

.focus-within\\:relative:focus-within {
    position: relative !important;
}

.focus-within\\:z-20:focus-within {
    z-index: 20 !important;
}

.focus-within\\:border-\\[\\#2563EB\\]:focus-within {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.focus-within\\:shadow-\\[0_0_0_3px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.1\\)\\]:focus-within {
    --tw-shadow: 0 0 0 3px rgba(37,99,235,0.1) !important;
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:scale-110:hover {
    --tw-scale-x: 1.1 !important;
    --tw-scale-y: 1.1 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:border-\\[\\#2563EB\\]:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-\\[\\#2746EB\\]\\/20:hover {
    border-color: rgb(39 70 235 / 0.2) !important;
}

.hover\\:border-\\[\\#98A2B3\\]:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(152 162 179 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-\\[\\#D0D5DD\\]:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(208 213 221 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-blue-300:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(147 197 253 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-blue-600:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-blue-700:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(29 78 216 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-green-700:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(21 128 61 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-green-800:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(22 101 52 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-violet-700:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(109 40 217 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-yellow-700:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(161 98 7 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-yellow-800:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(133 77 14 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#1C3BC7\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(28 59 199 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#1e3acc\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(30 58 204 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#1e3bb8\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(30 59 184 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#F0F2F5\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#F5F5F5\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#F5F7FA\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 247 250 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#F9FAFB\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#eef4fc\\]:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(238 244 252 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-black\\/5:hover {
    background-color: rgb(0 0 0 / 0.05) !important;
}

.hover\\:bg-black\\/80:hover {
    background-color: rgb(0 0 0 / 0.8) !important;
}

.hover\\:bg-blue-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-blue-700:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-gray-100:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-gray-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-green-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-green-800:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-neutral-100:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-neutral-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-slate-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-violet-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-violet-700:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-white:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-white\\/10:hover {
    background-color: rgb(255 255 255 / 0.1) !important;
}

.hover\\:bg-white\\/50:hover {
    background-color: rgb(255 255 255 / 0.5) !important;
}

.hover\\:bg-white\\/60:hover {
    background-color: rgb(255 255 255 / 0.6) !important;
}

.hover\\:bg-yellow-50:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-yellow-800:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(133 77 14 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-opacity-20:hover {
    --tw-bg-opacity: 0.2 !important;
}

.hover\\:text-\\[\\#0A0A0A\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(10 10 10 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#101928\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(16 25 40 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#1C3BC7\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(28 59 199 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#1C4AD0\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(28 74 208 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#344054\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#667185\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(102 113 133 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-blue-600:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-blue-700:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-blue-800:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(30 64 175 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-300:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(209 213 219 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-500:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-600:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-700:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-800:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-neutral-600:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-neutral-700:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(64 64 64 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-slate-500:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-slate-900:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-white:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:underline:hover {
    text-decoration-line: underline !important;
}

.hover\\:opacity-100:hover {
    opacity: 1 !important;
}

.hover\\:opacity-70:hover {
    opacity: 0.7 !important;
}

.hover\\:opacity-80:hover {
    opacity: 0.8 !important;
}

.hover\\:opacity-90:hover {
    opacity: 0.9 !important;
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover {
    --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent)) !important;
    --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-md:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-sm:hover {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-xl:hover {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:ring-4:hover {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:z-10:focus {
    z-index: 10 !important;
}

.focus\\:border-0:focus {
    border-width: 0px !important;
}

.focus\\:border-\\[\\#2563EB\\]:focus {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:bg-neutral-50:focus {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}

.focus\\:outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus\\:ring-0:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px !important;
}

.focus-visible\\:z-10:focus-visible {
    z-index: 10 !important;
}

.focus-visible\\:border-\\[\\#2563EB\\]:focus-visible {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.focus-visible\\:shadow-\\[0_0_0_3px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.1\\)\\]:focus-visible {
    --tw-shadow: 0 0 0 3px rgba(37,99,235,0.1) !important;
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus-visible\\:outline-none:focus-visible {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus-visible\\:outline:focus-visible {
    outline-style: solid !important;
}

.focus-visible\\:outline-1:focus-visible {
    outline-width: 1px !important;
}

.focus-visible\\:outline-2:focus-visible {
    outline-width: 2px !important;
}

.focus-visible\\:outline-offset-2:focus-visible {
    outline-offset: 2px !important;
}

.focus-visible\\:outline-blue-600:focus-visible {
    outline-color: #2563eb !important;
}

.focus-visible\\:outline-green-700:focus-visible {
    outline-color: #15803d !important;
}

.focus-visible\\:outline-violet-600:focus-visible {
    outline-color: #7c3aed !important;
}

.focus-visible\\:outline-yellow-700:focus-visible {
    outline-color: #a16207 !important;
}

.focus-visible\\:ring-0:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-1:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-2:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-4:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-\\[3px\\]:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-offset-1:focus-visible {
    --tw-ring-offset-width: 1px !important;
}

.active\\:scale-\\[0\\.97\\]:active {
    --tw-scale-x: 0.97 !important;
    --tw-scale-y: 0.97 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.active\\:scale-\\[0\\.98\\]:active {
    --tw-scale-x: 0.98 !important;
    --tw-scale-y: 0.98 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.active\\:border-blue-800:active {
    --tw-border-opacity: 1 !important;
    border-color: rgb(30 64 175 / var(--tw-border-opacity, 1)) !important;
}

.active\\:border-green-900:active {
    --tw-border-opacity: 1 !important;
    border-color: rgb(20 83 45 / var(--tw-border-opacity, 1)) !important;
}

.active\\:border-violet-800:active {
    --tw-border-opacity: 1 !important;
    border-color: rgb(91 33 182 / var(--tw-border-opacity, 1)) !important;
}

.active\\:border-yellow-900:active {
    --tw-border-opacity: 1 !important;
    border-color: rgb(113 63 18 / var(--tw-border-opacity, 1)) !important;
}

.active\\:bg-\\[\\#1C3BC7\\]:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(28 59 199 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-\\[\\#E4E7EC\\]:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-\\[\\#F0F2F5\\]:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-blue-800:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-gray-100:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-green-900:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(20 83 45 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-violet-800:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(91 33 182 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:bg-yellow-900:active {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(113 63 18 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:pointer-events-none:disabled {
    pointer-events: none !important;
}

.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}

.disabled\\:bg-\\[\\#8FB4F4\\]:disabled {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(143 180 244 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:bg-\\[\\#98A2B3\\]:disabled {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(152 162 179 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:bg-\\[\\#D0D5DD\\]:disabled {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(208 213 221 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:bg-gray-500:disabled {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:opacity-50:disabled {
    opacity: 0.5 !important;
}

.disabled\\:opacity-60:disabled {
    opacity: 0.6 !important;
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100 {
    opacity: 1 !important;
}

.group:hover .group-hover\\:-translate-y-0\\.5 {
    --tw-translate-y: -0.125rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group:hover .group-hover\\:translate-x-0\\.5 {
    --tw-translate-x: 0.125rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group:hover .group-hover\\:translate-x-1 {
    --tw-translate-x: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group:hover .group-hover\\:border-blue-600 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.group:hover .group-hover\\:border-green-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(21 128 61 / var(--tw-border-opacity, 1)) !important;
}

.group:hover .group-hover\\:border-violet-600 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(124 58 237 / var(--tw-border-opacity, 1)) !important;
}

.group:hover .group-hover\\:border-yellow-700 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(161 98 7 / var(--tw-border-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-blue-600 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-green-700 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-violet-600 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-yellow-700 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:from-blue-100 {
    --tw-gradient-from: #dbeafe var(--tw-gradient-from-position) !important;
    --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}

.group:hover .group-hover\\:to-blue-200 {
    --tw-gradient-to: #bfdbfe var(--tw-gradient-to-position) !important;
}

.group:hover .group-hover\\:text-blue-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(59 130 246 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:text-blue-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:text-blue-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:text-neutral-50 {
    --tw-text-opacity: 1 !important;
    color: rgb(250 250 250 / var(--tw-text-opacity, 1)) !important;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100 {
    opacity: 1 !important;
}

.group:hover .group-hover\\:opacity-0 {
    opacity: 0 !important;
}

.group:hover .group-hover\\:opacity-100 {
    opacity: 1 !important;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
    cursor: not-allowed !important;
}

.peer:disabled ~ .peer-disabled\\:opacity-50 {
    opacity: 0.5 !important;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
    opacity: 0.7 !important;
}

.has-\\[\\>svg\\]\\:grid-cols-\\[calc\\(var\\(--spacing\\)\\*4\\)_1fr\\]:has(>svg) {
    grid-template-columns: calc(var(--spacing) * 4) 1fr !important;
}

.has-\\[\\>svg\\]\\:gap-x-3:has(>svg) {
    column-gap: 0.75rem !important;
}

.has-\\[\\>svg\\]\\:px-2\\.5:has(>svg) {
    padding-left: 0.625rem !important;
    padding-right: 0.625rem !important;
}

.has-\\[\\>svg\\]\\:px-3:has(>svg) {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}

.has-\\[\\>svg\\]\\:px-4:has(>svg) {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
    pointer-events: none !important;
}

.aria-disabled\\:opacity-50[aria-disabled="true"] {
    opacity: 0.5 !important;
}

.aria-selected\\:opacity-100[aria-selected="true"] {
    opacity: 1 !important;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
    pointer-events: none !important;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
    pointer-events: none !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:inset-x-0[data-vaul-drawer-direction="bottom"] {
    left: 0px !important;
    right: 0px !important;
}

.data-\\[vaul-drawer-direction\\=left\\]\\:inset-y-0[data-vaul-drawer-direction="left"] {
    top: 0px !important;
    bottom: 0px !important;
}

.data-\\[vaul-drawer-direction\\=right\\]\\:inset-y-0[data-vaul-drawer-direction="right"] {
    top: 0px !important;
    bottom: 0px !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:inset-x-0[data-vaul-drawer-direction="top"] {
    left: 0px !important;
    right: 0px !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:bottom-0[data-vaul-drawer-direction="bottom"] {
    bottom: 0px !important;
}

.data-\\[vaul-drawer-direction\\=left\\]\\:left-0[data-vaul-drawer-direction="left"] {
    left: 0px !important;
}

.data-\\[vaul-drawer-direction\\=right\\]\\:right-0[data-vaul-drawer-direction="right"] {
    right: 0px !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:top-0[data-vaul-drawer-direction="top"] {
    top: 0px !important;
}

.data-\\[active\\=true\\]\\:z-10[data-active="true"] {
    z-index: 10 !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:mt-24[data-vaul-drawer-direction="bottom"] {
    margin-top: 6rem !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:mb-24[data-vaul-drawer-direction="top"] {
    margin-bottom: 6rem !important;
}

.data-\\[orientation\\=horizontal\\]\\:h-4[data-orientation="horizontal"] {
    height: 1rem !important;
}

.data-\\[orientation\\=horizontal\\]\\:h-full[data-orientation="horizontal"] {
    height: 100% !important;
}

.data-\\[orientation\\=horizontal\\]\\:h-px[data-orientation="horizontal"] {
    height: 1px !important;
}

.data-\\[orientation\\=vertical\\]\\:h-full[data-orientation="vertical"] {
    height: 100% !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
    height: 1px !important;
}

.data-\\[size\\=default\\]\\:h-9[data-size="default"] {
    height: 2.25rem !important;
}

.data-\\[size\\=sm\\]\\:h-8[data-size="sm"] {
    height: 2rem !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:max-h-\\[80vh\\][data-vaul-drawer-direction="bottom"] {
    max-height: 80vh !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:max-h-\\[80vh\\][data-vaul-drawer-direction="top"] {
    max-height: 80vh !important;
}

.data-\\[orientation\\=vertical\\]\\:min-h-44[data-orientation="vertical"] {
    min-height: 11rem !important;
}

.data-\\[orientation\\=horizontal\\]\\:w-full[data-orientation="horizontal"] {
    width: 100% !important;
}

.data-\\[orientation\\=vertical\\]\\:w-1\\.5[data-orientation="vertical"] {
    width: 0.375rem !important;
}

.data-\\[orientation\\=vertical\\]\\:w-auto[data-orientation="vertical"] {
    width: auto !important;
}

.data-\\[orientation\\=vertical\\]\\:w-full[data-orientation="vertical"] {
    width: 100% !important;
}

.data-\\[orientation\\=vertical\\]\\:w-px[data-orientation="vertical"] {
    width: 1px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
    width: 100% !important;
}

.data-\\[vaul-drawer-direction\\=left\\]\\:w-3\\/4[data-vaul-drawer-direction="left"] {
    width: 75% !important;
}

.data-\\[vaul-drawer-direction\\=right\\]\\:w-3\\/4[data-vaul-drawer-direction="right"] {
    width: 75% !important;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
    --tw-translate-y: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
    --tw-translate-x: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
    --tw-translate-x: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
    --tw-translate-y: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=checked\\]\\:translate-x-\\[calc\\(100\\%-2px\\)\\][data-state="checked"] {
    --tw-translate-x: calc(100% - 2px) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[orientation\\=vertical\\]\\:flex-col[data-orientation="vertical"] {
    flex-direction: column !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
    flex-direction: column !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:rounded-t-lg[data-vaul-drawer-direction="bottom"] {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:rounded-b-lg[data-vaul-drawer-direction="top"] {
    border-bottom-right-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
}

.data-\\[variant\\=outline\\]\\:border-l-0[data-variant="outline"] {
    border-left-width: 0px !important;
}

.data-\\[vaul-drawer-direction\\=bottom\\]\\:border-t[data-vaul-drawer-direction="bottom"] {
    border-top-width: 1px !important;
}

.data-\\[vaul-drawer-direction\\=left\\]\\:border-r[data-vaul-drawer-direction="left"] {
    border-right-width: 1px !important;
}

.data-\\[vaul-drawer-direction\\=right\\]\\:border-l[data-vaul-drawer-direction="right"] {
    border-left-width: 1px !important;
}

.data-\\[vaul-drawer-direction\\=top\\]\\:border-b[data-vaul-drawer-direction="top"] {
    border-bottom-width: 1px !important;
}

.data-\\[highlighted\\]\\:bg-neutral-50[data-highlighted] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}

.data-\\[inset\\]\\:pl-8[data-inset] {
    padding-left: 2rem !important;
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"] {
    font-weight: 500 !important;
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
    opacity: 0.5 !important;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
    opacity: 0.5 !important;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"] {
    opacity: 1 !important;
}

.data-\\[active\\=true\\]\\:ring-\\[3px\\][data-active="true"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
    transition-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
    transition-duration: 500ms !important;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
    --tw-exit-scale: .95 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
    --tw-enter-scale: .9 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
    --tw-enter-scale: .95 !important;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
    --tw-enter-translate-x: 13rem !important;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
    --tw-enter-translate-x: -13rem !important;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
    --tw-exit-translate-x: 13rem !important;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
    --tw-exit-translate-x: -13rem !important;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
    --tw-enter-translate-y: -0.5rem !important;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
    --tw-enter-translate-x: 0.5rem !important;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
    --tw-enter-translate-x: -0.5rem !important;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
    --tw-enter-translate-y: 0.5rem !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
    --tw-exit-translate-y: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
    --tw-exit-translate-x: -100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
    --tw-exit-translate-x: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
    --tw-exit-translate-y: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
    --tw-enter-translate-y: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
    --tw-enter-translate-x: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
    --tw-enter-translate-x: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
    --tw-enter-translate-y: -100% !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
    animation-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
    animation-duration: 500ms !important;
}

.\\*\\:data-\\[slot\\=select-value\\]\\:line-clamp-1[data-slot="select-value"] > * {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
}

.\\*\\:data-\\[slot\\=select-value\\]\\:flex[data-slot="select-value"] > * {
    display: flex !important;
}

.\\*\\:data-\\[slot\\=select-value\\]\\:items-center[data-slot="select-value"] > * {
    align-items: center !important;
}

.\\*\\:data-\\[slot\\=select-value\\]\\:gap-2[data-slot="select-value"] > * {
    gap: 0.5rem !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    left: 0px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    height: 0.25rem !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    width: 100% !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[variant\\=outline\\]\\:first\\:border-l:first-child[data-variant="outline"] {
    border-left-width: 1px !important;
}

.group[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\:pointer-events-none {
    pointer-events: none !important;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
    left: calc(var(--sidebar-width) * -1) !important;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
    right: calc(var(--sidebar-width) * -1) !important;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4 {
    right: -1rem !important;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0 {
    left: 0px !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:top-full {
    top: 100% !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8 {
    margin-top: -2rem !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:mt-1\\.5 {
    margin-top: 0.375rem !important;
}

.group\\/drawer-content[data-vaul-drawer-direction="bottom"] .group-data-\\[vaul-drawer-direction\\=bottom\\]\\/drawer-content\\:block {
    display: block !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden {
    display: none !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\)\\] {
    width: calc(var(--sidebar-width-icon) + (--spacing(4))) !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\+2px\\)\\] {
    width: calc(var(--sidebar-width-icon) + (--spacing(4)) + 2px) !important;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0 {
    width: 0px !important;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0 {
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180 {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden {
    overflow: hidden !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:overflow-hidden {
    overflow: hidden !important;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg {
    border-radius: 0.5rem !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:rounded-md {
    border-radius: 0.375rem !important;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border {
    border-width: 1px !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:border {
    border-width: 1px !important;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r {
    border-right-width: 1px !important;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l {
    border-left-width: 1px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0 {
    opacity: 0 !important;
}

.group[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\:opacity-50 {
    opacity: 0.5 !important;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:duration-200 {
    transition-duration: 200ms !important;
    animation-duration: 200ms !important;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after {
    content: var(--tw-content) !important;
    left: 100% !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
    --tw-exit-opacity: 0 !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
    --tw-enter-opacity: 0 !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
    --tw-exit-scale: .95 !important;
}

.group\\/navigation-menu[data-viewport="false"] .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
    --tw-enter-scale: .95 !important;
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5 {
    top: 0.375rem !important;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5 {
    top: 0.625rem !important;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1 {
    top: 0.25rem !important;
}

@media not all and (min-width: 768px) {
    .max-md\\:absolute {
        position: absolute !important;
    }
    .max-md\\:inset-0 {
        inset: 0px !important;
    }
    .max-md\\:z-\\[1\\] {
        z-index: 1 !important;
    }
}

@media (max-width: 768px) {
    .max-\\[768px\\]\\:h-3\\.5 {
        height: 0.875rem !important;
    }
    .max-\\[768px\\]\\:h-5 {
        height: 1.25rem !important;
    }
    .max-\\[768px\\]\\:min-h-\\[38px\\] {
        min-height: 38px !important;
    }
    .max-\\[768px\\]\\:w-3\\.5 {
        width: 0.875rem !important;
    }
    .max-\\[768px\\]\\:w-5 {
        width: 1.25rem !important;
    }
    .max-\\[768px\\]\\:py-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }
}

@media (min-width: 640px) {
    .sm\\:my-6 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }
    .sm\\:mb-10 {
        margin-bottom: 2.5rem !important;
    }
    .sm\\:mb-6 {
        margin-bottom: 1.5rem !important;
    }
    .sm\\:mb-8 {
        margin-bottom: 2rem !important;
    }
    .sm\\:mt-12 {
        margin-top: 3rem !important;
    }
    .sm\\:mt-4 {
        margin-top: 1rem !important;
    }
    .sm\\:block {
        display: block !important;
    }
    .sm\\:flex {
        display: flex !important;
    }
    .sm\\:h-14 {
        height: 3.5rem !important;
    }
    .sm\\:h-6 {
        height: 1.5rem !important;
    }
    .sm\\:h-\\[24px\\] {
        height: 24px !important;
    }
    .sm\\:h-\\[36px\\] {
        height: 36px !important;
    }
    .sm\\:h-\\[38px\\] {
        height: 38px !important;
    }
    .sm\\:h-auto {
        height: auto !important;
    }
    .sm\\:w-1\\/2 {
        width: 50% !important;
    }
    .sm\\:w-12 {
        width: 3rem !important;
    }
    .sm\\:w-6 {
        width: 1.5rem !important;
    }
    .sm\\:w-\\[160px\\] {
        width: 160px !important;
    }
    .sm\\:min-w-\\[240px\\] {
        min-width: 240px !important;
    }
    .sm\\:max-w-\\[500px\\] {
        max-width: 500px !important;
    }
    .sm\\:max-w-\\[85\\%\\] {
        max-width: 85% !important;
    }
    .sm\\:max-w-lg {
        max-width: 32rem !important;
    }
    .sm\\:max-w-none {
        max-width: none !important;
    }
    .sm\\:max-w-sm {
        max-width: 24rem !important;
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .sm\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .sm\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .sm\\:flex-row {
        flex-direction: row !important;
    }
    .sm\\:items-center {
        align-items: center !important;
    }
    .sm\\:justify-end {
        justify-content: flex-end !important;
    }
    .sm\\:gap-12 {
        gap: 3rem !important;
    }
    .sm\\:gap-2\\.5 {
        gap: 0.625rem !important;
    }
    .sm\\:gap-3 {
        gap: 0.75rem !important;
    }
    .sm\\:gap-4 {
        gap: 1rem !important;
    }
    .sm\\:gap-6 {
        gap: 1.5rem !important;
    }
    .sm\\:rounded-3xl {
        border-radius: 1.5rem !important;
    }
    .sm\\:p-4 {
        padding: 1rem !important;
    }
    .sm\\:p-6 {
        padding: 1.5rem !important;
    }
    .sm\\:p-8 {
        padding: 2rem !important;
    }
    .sm\\:px-1\\.5 {
        padding-left: 0.375rem !important;
        padding-right: 0.375rem !important;
    }
    .sm\\:px-3 {
        padding-left: 0.75rem !important;
        padding-right: 0.75rem !important;
    }
    .sm\\:px-4 {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
    .sm\\:px-6 {
        padding-left: 1.5rem !important;
        padding-right: 1.5rem !important;
    }
    .sm\\:px-8 {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
    .sm\\:py-16 {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important;
    }
    .sm\\:py-4 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }
    .sm\\:py-8 {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important;
    }
    .sm\\:py-px {
        padding-top: 1px !important;
        padding-bottom: 1px !important;
    }
    .sm\\:pb-20 {
        padding-bottom: 5rem !important;
    }
    .sm\\:pl-2\\.5 {
        padding-left: 0.625rem !important;
    }
    .sm\\:pr-2\\.5 {
        padding-right: 0.625rem !important;
    }
    .sm\\:pt-3 {
        padding-top: 0.75rem !important;
    }
    .sm\\:pt-36 {
        padding-top: 9rem !important;
    }
    .sm\\:text-left {
        text-align: left !important;
    }
    .sm\\:text-2xl {
        font-size: 1.5rem !important;
        line-height: 2rem !important;
    }
    .sm\\:text-4xl {
        font-size: 2.25rem !important;
        line-height: 2.5rem !important;
    }
    .sm\\:text-\\[11px\\] {
        font-size: 11px !important;
    }
    .sm\\:text-\\[13px\\] {
        font-size: 13px !important;
    }
    .sm\\:text-\\[14px\\] {
        font-size: 14px !important;
    }
    .sm\\:text-\\[15px\\] {
        font-size: 15px !important;
    }
    .sm\\:text-\\[16px\\] {
        font-size: 16px !important;
    }
    .sm\\:text-\\[18px\\] {
        font-size: 18px !important;
    }
    .sm\\:text-base {
        font-size: 1rem !important;
        line-height: 1.5rem !important;
    }
    .sm\\:text-lg {
        font-size: 1.125rem !important;
        line-height: 1.75rem !important;
    }
    .sm\\:text-sm {
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
    .sm\\:leading-\\[1\\.05\\] {
        line-height: 1.05 !important;
    }
    .data-\\[vaul-drawer-direction\\=left\\]\\:sm\\:max-w-sm[data-vaul-drawer-direction="left"] {
        max-width: 24rem !important;
    }
    .data-\\[vaul-drawer-direction\\=right\\]\\:sm\\:max-w-sm[data-vaul-drawer-direction="right"] {
        max-width: 24rem !important;
    }
}

@media (min-width: 768px) {
    .md\\:absolute {
        position: absolute !important;
    }
    .md\\:bottom-4 {
        bottom: 1rem !important;
    }
    .md\\:left-4 {
        left: 1rem !important;
    }
    .md\\:my-8 {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important;
    }
    .md\\:mb-3 {
        margin-bottom: 0.75rem !important;
    }
    .md\\:mb-4 {
        margin-bottom: 1rem !important;
    }
    .md\\:mb-6 {
        margin-bottom: 1.5rem !important;
    }
    .md\\:mb-8 {
        margin-bottom: 2rem !important;
    }
    .md\\:ml-\\[210px\\] {
        margin-left: 210px !important;
    }
    .md\\:mt-20 {
        margin-top: 5rem !important;
    }
    .md\\:mt-3 {
        margin-top: 0.75rem !important;
    }
    .md\\:mt-6 {
        margin-top: 1.5rem !important;
    }
    .md\\:block {
        display: block !important;
    }
    .md\\:inline {
        display: inline !important;
    }
    .md\\:flex {
        display: flex !important;
    }
    .md\\:grid {
        display: grid !important;
    }
    .md\\:hidden {
        display: none !important;
    }
    .md\\:h-14 {
        height: 3.5rem !important;
    }
    .md\\:h-6 {
        height: 1.5rem !important;
    }
    .md\\:h-7 {
        height: 1.75rem !important;
    }
    .md\\:h-8 {
        height: 2rem !important;
    }
    .md\\:h-96 {
        height: 24rem !important;
    }
    .md\\:h-\\[60px\\] {
        height: 60px !important;
    }
    .md\\:h-auto {
        height: auto !important;
    }
    .md\\:max-h-6 {
        max-height: 1.5rem !important;
    }
    .md\\:max-h-7 {
        max-height: 1.75rem !important;
    }
    .md\\:max-h-\\[calc\\(100vh-24px\\)\\] {
        max-height: calc(100vh - 24px) !important;
    }
    .md\\:min-h-6 {
        min-height: 1.5rem !important;
    }
    .md\\:min-h-7 {
        min-height: 1.75rem !important;
    }
    .md\\:min-h-8 {
        min-height: 2rem !important;
    }
    .md\\:w-2\\/3 {
        width: 66.666667% !important;
    }
    .md\\:w-6 {
        width: 1.5rem !important;
    }
    .md\\:w-\\[180px\\] {
        width: 180px !important;
    }
    .md\\:w-\\[200px\\] {
        width: 200px !important;
    }
    .md\\:w-\\[266px\\] {
        width: 266px !important;
    }
    .md\\:w-\\[360px\\] {
        width: 360px !important;
    }
    .md\\:w-\\[400px\\] {
        width: 400px !important;
    }
    .md\\:w-\\[45\\%\\] {
        width: 45% !important;
    }
    .md\\:w-\\[50\\%\\] {
        width: 50% !important;
    }
    .md\\:w-\\[50px\\] {
        width: 50px !important;
    }
    .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
        width: var(--radix-navigation-menu-viewport-width) !important;
    }
    .md\\:w-auto {
        width: auto !important;
    }
    .md\\:min-w-6 {
        min-width: 1.5rem !important;
    }
    .md\\:max-w-6 {
        max-width: 1.5rem !important;
    }
    .md\\:max-w-\\[220px\\] {
        max-width: 220px !important;
    }
    .md\\:max-w-none {
        max-width: none !important;
    }
    .md\\:flex-1 {
        flex: 1 1 !important;
    }
    .md\\:flex-none {
        flex: none !important;
    }
    .md\\:flex-shrink-0 {
        flex-shrink: 0 !important;
    }
    .md\\:shrink-0 {
        flex-shrink: 0 !important;
    }
    .md\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-\\[56px_minmax\\(0\\2c 1fr\\)_minmax\\(72px\\2c 100px\\)_minmax\\(96px\\2c 110px\\)_minmax\\(72px\\2c 90px\\)_90px\\] {
        grid-template-columns: 56px minmax(0,1fr) minmax(72px,100px) minmax(96px,110px) minmax(72px,90px) 90px !important;
    }
    .md\\:flex-row {
        flex-direction: row !important;
    }
    .md\\:items-center {
        align-items: center !important;
    }
    .md\\:justify-center {
        justify-content: center !important;
    }
    .md\\:justify-between {
        justify-content: space-between !important;
    }
    .md\\:gap-1\\.5 {
        gap: 0.375rem !important;
    }
    .md\\:gap-2 {
        gap: 0.5rem !important;
    }
    .md\\:gap-3 {
        gap: 0.75rem !important;
    }
    .md\\:gap-4 {
        gap: 1rem !important;
    }
    .md\\:gap-6 {
        gap: 1.5rem !important;
    }
    .md\\:gap-8 {
        gap: 2rem !important;
    }
    .md\\:space-y-24 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0 !important;
        margin-top: calc(6rem * calc(1 - var(--tw-space-y-reverse))) !important;
        margin-bottom: calc(6rem * var(--tw-space-y-reverse)) !important;
    }
    .md\\:overflow-hidden {
        overflow: hidden !important;
    }
    .md\\:overflow-visible {
        overflow: visible !important;
    }
    .md\\:rounded-\\[16px\\] {
        border-radius: 16px !important;
    }
    .md\\:rounded-full {
        border-radius: 9999px !important;
    }
    .md\\:border-b {
        border-bottom-width: 1px !important;
    }
    .md\\:border-l-0 {
        border-left-width: 0px !important;
    }
    .md\\:border-r {
        border-right-width: 1px !important;
    }
    .md\\:p-0\\.5 {
        padding: 0.125rem !important;
    }
    .md\\:p-2 {
        padding: 0.5rem !important;
    }
    .md\\:p-2\\.5 {
        padding: 0.625rem !important;
    }
    .md\\:p-8 {
        padding: 2rem !important;
    }
    .md\\:px-10 {
        padding-left: 2.5rem !important;
        padding-right: 2.5rem !important;
    }
    .md\\:px-2 {
        padding-left: 0.5rem !important;
        padding-right: 0.5rem !important;
    }
    .md\\:px-3 {
        padding-left: 0.75rem !important;
        padding-right: 0.75rem !important;
    }
    .md\\:px-5 {
        padding-left: 1.25rem !important;
        padding-right: 1.25rem !important;
    }
    .md\\:px-8 {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
    .md\\:py-1\\.5 {
        padding-top: 0.375rem !important;
        padding-bottom: 0.375rem !important;
    }
    .md\\:py-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }
    .md\\:py-4 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }
    .md\\:py-6 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }
    .md\\:py-\\[5\\.5px\\] {
        padding-top: 5.5px !important;
        padding-bottom: 5.5px !important;
    }
    .md\\:pb-0 {
        padding-bottom: 0px !important;
    }
    .md\\:pb-3 {
        padding-bottom: 0.75rem !important;
    }
    .md\\:pb-6 {
        padding-bottom: 1.5rem !important;
    }
    .md\\:pt-24 {
        padding-top: 6rem !important;
    }
    .md\\:pt-\\[100px\\] {
        padding-top: 100px !important;
    }
    .md\\:text-4xl {
        font-size: 2.25rem !important;
        line-height: 2.5rem !important;
    }
    .md\\:text-5xl {
        font-size: 3rem !important;
        line-height: 1 !important;
    }
    .md\\:text-\\[14px\\] {
        font-size: 14px !important;
    }
    .md\\:text-sm {
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
    .md\\:text-xl {
        font-size: 1.25rem !important;
        line-height: 1.75rem !important;
    }
    .md\\:text-\\[\\#FAFAFA\\] {
        --tw-text-opacity: 1 !important;
        color: rgb(250 250 250 / var(--tw-text-opacity, 1)) !important;
    }
    .md\\:opacity-0 {
        opacity: 0 !important;
    }
    .md\\:after\\:hidden::after {
        content: var(--tw-content) !important;
        display: none !important;
    }
    .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2 {
        margin: 0.5rem !important;
    }
    .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0 {
        margin-left: 0px !important;
    }
    .peer[data-variant="inset"][data-state="collapsed"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:peer-data-\\[state\\=collapsed\\]\\:ml-2 {
        margin-left: 0.5rem !important;
    }
    .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl {
        border-radius: 0.75rem !important;
    }
    .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow-sm {
        --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
        --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
    }
}

@media (min-width: 1024px) {
    .lg\\:order-1 {
        order: 1 !important;
    }
    .lg\\:order-2 {
        order: 2 !important;
    }
    .lg\\:my-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }
    .lg\\:mt-2 {
        margin-top: 0.5rem !important;
    }
    .lg\\:block {
        display: block !important;
    }
    .lg\\:flex {
        display: flex !important;
    }
    .lg\\:hidden {
        display: none !important;
    }
    .lg\\:h-\\[40px\\] {
        height: 40px !important;
    }
    .lg\\:h-\\[85vh\\] {
        height: 85vh !important;
    }
    .lg\\:w-1\\/2 {
        width: 50% !important;
    }
    .lg\\:max-w-\\[550px\\] {
        max-width: 550px !important;
    }
    .lg\\:max-w-\\[640px\\] {
        max-width: 640px !important;
    }
    .lg\\:max-w-\\[min\\(100\\%\\2c 760px\\)\\] {
        max-width: min(100%, 760px) !important;
    }
    .lg\\:max-w-md {
        max-width: 28rem !important;
    }
    .lg\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-5 {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }
    .lg\\:flex-row {
        flex-direction: row !important;
    }
    .lg\\:items-stretch {
        align-items: stretch !important;
    }
    .lg\\:gap-0 {
        gap: 0px !important;
    }
    .lg\\:gap-16 {
        gap: 4rem !important;
    }
    .lg\\:gap-3 {
        gap: 0.75rem !important;
    }
    .lg\\:overflow-auto {
        overflow: auto !important;
    }
    .lg\\:rounded-\\[24px\\] {
        border-radius: 24px !important;
    }
    .lg\\:border-0 {
        border-width: 0px !important;
    }
    .lg\\:p-10 {
        padding: 2.5rem !important;
    }
    .lg\\:p-8 {
        padding: 2rem !important;
    }
    .lg\\:px-10 {
        padding-left: 2.5rem !important;
        padding-right: 2.5rem !important;
    }
    .lg\\:px-14 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important;
    }
    .lg\\:px-5 {
        padding-left: 1.25rem !important;
        padding-right: 1.25rem !important;
    }
    .lg\\:px-8 {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
    .lg\\:py-10 {
        padding-top: 2.5rem !important;
        padding-bottom: 2.5rem !important;
    }
    .lg\\:pb-10 {
        padding-bottom: 2.5rem !important;
    }
    .lg\\:pb-20 {
        padding-bottom: 5rem !important;
    }
    .lg\\:pt-0 {
        padding-top: 0px !important;
    }
    .lg\\:pt-20 {
        padding-top: 5rem !important;
    }
    .lg\\:pt-32 {
        padding-top: 8rem !important;
    }
    .lg\\:text-center {
        text-align: center !important;
    }
    .lg\\:text-4xl {
        font-size: 2.25rem !important;
        line-height: 2.5rem !important;
    }
    .lg\\:text-5xl {
        font-size: 3rem !important;
        line-height: 1 !important;
    }
    .lg\\:text-6xl {
        font-size: 3.75rem !important;
        line-height: 1 !important;
    }
    .lg\\:text-\\[15px\\] {
        font-size: 15px !important;
    }
    .lg\\:text-\\[16px\\] {
        font-size: 16px !important;
    }
    .lg\\:text-\\[20px\\] {
        font-size: 20px !important;
    }
    .lg\\:shadow-none {
        --tw-shadow: 0 0 #0000 !important;
        --tw-shadow-colored: 0 0 #0000 !important;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
    }
}

@media (min-width: 1280px) {
    .xl\\:w-1\\/3 {
        width: 33.333333% !important;
    }
    .xl\\:w-2\\/3 {
        width: 66.666667% !important;
    }
    .xl\\:max-w-\\[450px\\] {
        max-width: 450px !important;
    }
    .xl\\:grid-cols-7 {
        grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
    }
    .xl\\:text-7xl {
        font-size: 4.5rem !important;
        line-height: 1 !important;
    }
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
    border-radius: 0.375rem !important;
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
    padding-right: 0px !important;
}

.\\[\\&\\:last-child\\]\\:pb-6:last-child {
    padding-bottom: 1.5rem !important;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
    --tw-translate-y: 2px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>button\\]\\:hidden>button {
    display: none !important;
}

.\\[\\&\\>p\\]\\:mb-0>p {
    margin-bottom: 0px !important;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}

.\\[\\&\\>svg\\]\\:pointer-events-none>svg {
    pointer-events: none !important;
}

.\\[\\&\\>svg\\]\\:size-3>svg {
    width: 0.75rem !important;
    height: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
    width: 0.875rem !important;
    height: 0.875rem !important;
}

.\\[\\&\\>svg\\]\\:size-4>svg {
    width: 1rem !important;
    height: 1rem !important;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg {
    height: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:h-3>svg {
    height: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg {
    width: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:w-3>svg {
    width: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg {
    flex-shrink: 0 !important;
}

.\\[\\&\\>svg\\]\\:translate-y-0\\.5>svg {
    --tw-translate-y: 0.125rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>svg\\]\\:text-current>svg {
    color: currentColor !important;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
    border-bottom-width: 0px !important;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff'] {
    stroke: transparent !important;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff'] {
    stroke: transparent !important;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
    font-weight: 500 !important;
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
    padding-top: 0px !important;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
    height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
    width: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
    height: 3rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
    height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
    width: 1.25rem !important;
}

.\\[\\&_p\\]\\:leading-relaxed p {
    line-height: 1.625 !important;
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 svg:not([class*='size-']) {
    width: 1rem !important;
    height: 1rem !important;
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
    pointer-events: none !important;
}

.\\[\\&_svg\\]\\:size-4 svg {
    width: 1rem !important;
    height: 1rem !important;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
    flex-shrink: 0 !important;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
    border-width: 0px !important;
}

.\\[\\&_tr\\]\\:border-b tr {
    border-bottom-width: 1px !important;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
    right: -0.5rem !important;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
    cursor: e-resize !important;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
    left: -0.5rem !important;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
    cursor: w-resize !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;sBAEsB;AACtB;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,uBAAc;IAAd,4BAAc;IAAd,iBAAc;IAAd,iCAAc;IAAd,oBAAc;IAAd,oCAAc;IAAd,4BAAc;IAAd,iCAAc;IAAd,wBAAc;IAAd,sCAAc;IAAd,oBAAc;IAAd,qCAAc;IAAd,qBAAc;IAAd,mCAAc;IAAd,4BAAc;IAAd,qCAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,yBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,gBAAc;EAAA;AAAd;IAAA,4BAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,yBAAc;IAAd,iCAAc;IAAd,4BAAc;IAAd,oCAAc;IAAd,8BAAc;IAAd,mCAAc;IAAd,0BAAc;IAAd,mCAAc;IAAd,2BAAc;IAAd,gCAAc;IAAd,4BAAc;IAAd,qCAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;EAAA;AACd;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AACpB;IAAA,6BAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,uBAAmB;IAAnB,2BAAmB;IAAnB,iCAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,+BAAmB;IAAnB,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,+BAAmB;IAAnB,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6CAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,eAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,iEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,2EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,6EAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uEAAmB;IAAnB,8EAAmB;IAAnB;AAAmB;AAAnB;IAAA,oFAAmB;IAAnB,8EAAmB;IAAnB;AAAmB;AAAnB;IAAA,uEAAmB;IAAnB,8EAAmB;IAAnB;AAAmB;AAAnB;IAAA,uEAAmB;IAAnB,gFAAmB;IAAnB;AAAmB;AAAnB;IAAA,uEAAmB;IAAnB,gFAAmB;IAAnB;AAAmB;AAAnB;IAAA,2EAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,oEAAmB;IAAnB,gFAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB;AAAmB;AAAnB;IAAA,iFAAmB;IAAnB;AAAmB;AAAnB;IAAA,2EAAmB;IAAnB;AAAmB;AAAnB;IAAA,iFAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qFAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2DAAmB;IAAnB,wEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,oFAAmB;IAAnB,kGAAmB;IAAnB;AAAmB;AAAnB;IAAA,kDAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,gEAAmB;IAAnB,uGAAmB;IAAnB;AAAmB;AAAnB;IAAA,iDAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2DAAmB;IAAnB,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA,sDAAmB;IAAnB,oEAAmB;IAAnB;AAAmB;AAAnB;IAAA,sDAAmB;IAAnB,oEAAmB;IAAnB;AAAmB;AAAnB;IAAA,sEAAmB;IAAnB,6GAAmB;IAAnB;AAAmB;AAAnB;IAAA,sFAAmB;IAAnB,6GAAmB;IAAnB;AAAmB;AAAnB;IAAA,yFAAmB;IAAnB,gHAAmB;IAAnB;AAAmB;AAAnB;IAAA,0FAAmB;IAAnB,8GAAmB;IAAnB;AAAmB;AAAnB;IAAA,wFAAmB;IAAnB,4GAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2FAAmB;IAAnB,+GAAmB;IAAnB;AAAmB;AAAnB;IAAA,kDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6GAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mKAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2DAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,oDAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,qCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0GAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,mCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;QAAA,kCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA,gCAAmB;IAAnB,oCAAmB;IAAnB,sCAAmB;IAAnB,oCAAmB;IAAnB,qCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAkEjB;IACE;;MAEE,sBAAsB;MACtB,aAAa;IACf;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;AAEA;IACE,oEAAyD;EAC3D;AAhFF;IAAA;AAAmB;;AAEnB,4BAA4B;;;AAkF5B;IACI,uBAAuB;IACvB,UAAU;IACV,SAAS;EACX;;AAEF;IACI,mDAAuC;IACvC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,uBAAuB;QACvB,4BAA4B;IAChC;AACJ;;AAEA;IACI,mDAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI;QACI,4BAA4B;QAC5B,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mDAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI;QACI,4BAA4B;QAC5B,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB;mCAC+B;IAC/B,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;EAEE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc,EAAE,gBAAgB;IAChC,eAAe,EAAE,gBAAgB;IACjC,oDAAoD,EAAE,kCAAkC;IACxF,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;;CAE9C;CACA;IACG,KAAK,0BAA0B,EAAE;IACjC,OAAO,4BAA4B,EAAE;EACvC;EACA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE;QACI,eAAe;QACf,eAAe;IACnB;EACF;;EAEA;IACE;QACI,eAAe;QACf,eAAe;IACnB;EACF;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE;QACI,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;EACF;;EAEA;IACE;QACI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;EACF;;AAEF,2CAA2C;AAC3C;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;;;;;;EAME,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,kCAAkC;AACpC;;AAEA;;;;;;EAME,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,uCAAuC;IACvC,YAAY;EACd;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EAUE;;;;;;;;GAQC;AACH;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;;IAEE,qCAAqC;IACrC,aAAa;EACf;EACA;IACE,wCAAwC;IACxC,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,0DAA0D;AAC5D;;AAEA;EACE,6DAA6D;EAC7D,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;EAC7D,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE;;IAEE,sDAAsD;EACxD;EACA;IACE,qDAAqD;EACvD;EACA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE;;IAEE,qDAAqD;EACvD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,qDAAqD;EACvD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAhqBA;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,8BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD,mBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,2CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,4CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qDAgqBC;IAhqBD,gEAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,4BAgqBC;IAhqBD,4BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,4DAgqBC;IAhqBD,gEAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,0FAgqBC;IAhqBD,8GAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,wFAgqBC;IAhqBD,4GAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qDAgqBC;IAhqBD,kEAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,2FAgqBC;IAhqBD,+GAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qDAgqBC;IAhqBD,gEAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,sCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,oCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,uEAgqBC;IAhqBD,gFAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,oBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,mBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,mBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,oBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,oCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,oCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,sHAgqBC;IAhqBD,oHAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD,oCAgqBC;IAhqBD,sCAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,0CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD,oCAgqBC;IAhqBD,sCAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,0CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD,oCAgqBC;IAhqBD,sCAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,0CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,mCAgqBC;IAhqBD,oCAgqBC;IAhqBD,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,mCAgqBC;IAhqBD,oCAgqBC;IAhqBD,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,mCAgqBC;IAhqBD,oCAgqBC;IAhqBD,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,2BAgqBC;IAhqBD,+BAgqBC;IAhqBD,uCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD,iCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,8BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,8BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,qDAgqBC;IAhqBD,kEAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qFAgqBC;IAhqBD,yGAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD,oCAgqBC;IAhqBD,sCAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,0CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD,oCAgqBC;IAhqBD,qCAgqBC;IAhqBD,mCAgqBC;IAhqBD,oCAgqBC;IAhqBD,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;AAAA;;AAhqBD;IAAA;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;AAAA;;AAhqBD;IAAA;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,iCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,gCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,2BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,0BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;AAAA;;AAhqBD;IAAA;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,2BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,kCAgqBC;QAhqBD,uEAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,gCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,gCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,gCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,0BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,qCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,qDAgqBC;QAhqBD,kEAgqBC;QAhqBD;IAgqBC;AAAA;;AAhqBD;IAAA;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,+BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,gCAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,8BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,0BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA,6BAgqBC;QAhqBD;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,iCAgqBC;QAhqBD,yCAgqBC;QAhqBD;IAgqBC;AAAA;;AAhqBD;IAAA;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA;IAgqBC;IAhqBD;QAAA,4BAgqBC;QAhqBD;IAgqBC;AAAA;;AAhqBD;IAAA,4CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,2CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,2CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,4CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,4CAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,2BAgqBC;IAhqBD,kCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,yBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,0BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,sBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,qCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,8BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,yCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,gCAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,6BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA,+BAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,sBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA,sBAgqBC;IAhqBD;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC;;AAhqBD;IAAA;AAgqBC","sourcesContent":["/* @tailwind base;\n@tailwind components;\n@tailwind utilities; */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* optional shadcn imports */\n\n@import \"shadcn/tailwind.css\";\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 222.2 84% 4.9%;\n    --card: 0 0% 100%;\n    --card-foreground: 222.2 84% 4.9%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 222.2 84% 4.9%;\n    --primary: 221.2 83.2% 53.3%;\n    --primary-foreground: 210 40% 98%;\n    --secondary: 210 40% 96%;\n    --secondary-foreground: 222.2 84% 4.9%;\n    --muted: 210 40% 96%;\n    --muted-foreground: 215.4 16.3% 46.9%;\n    --accent: 210 40% 96%;\n    --accent-foreground: 222.2 84% 4.9%;\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 210 40% 98%;\n    --border: 214.3 31.8% 91.4%;\n    --input: 214.3 31.8% 91.4%;\n    --ring: 221.2 83.2% 53.3%;\n    --chart-1: 12 76% 61%;\n    --chart-2: 173 58% 39%;\n    --chart-3: 197 37% 24%;\n    --chart-4: 43 74% 66%;\n    --chart-5: 27 87% 67%;\n    --radius: 0.5rem;\n  }\n\n  .dark {\n    --background: 222.2 84% 4.9%;\n    --foreground: 210 40% 98%;\n    --card: 222.2 84% 4.9%;\n    --card-foreground: 210 40% 98%;\n    --popover: 222.2 84% 4.9%;\n    --popover-foreground: 210 40% 98%;\n    --primary: 217.2 91.2% 59.8%;\n    --primary-foreground: 222.2 84% 4.9%;\n    --secondary: 217.2 32.6% 17.5%;\n    --secondary-foreground: 210 40% 98%;\n    --muted: 217.2 32.6% 17.5%;\n    --muted-foreground: 215 20.2% 65.1%;\n    --accent: 217.2 32.6% 17.5%;\n    --accent-foreground: 210 40% 98%;\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 210 40% 98%;\n    --border: 217.2 32.6% 17.5%;\n    --input: 217.2 32.6% 17.5%;\n    --ring: 224.3 76.3% 94.1%;\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n  }\n}\n\n\n\n@layer utilities {\n  @keyframes dockie-loader-bounce {\n    0%,\n    100% {\n      transform: scale(0.92);\n      opacity: 0.72;\n    }\n    50% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n\n  .dockie-loader-bounce {\n    animation: dockie-loader-bounce 2.4s ease-in-out infinite;\n  }\n}\n\n\nhtml {\n    scroll-behavior: smooth;\n    padding: 0;\n    margin: 0;\n  }\n\n.hero-section {\n    background: url(\"./assets/hero-bg.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100%;\n    min-height: 45vh;\n    height: auto;\n    background-color: #00000066;\n    object-fit: contain;\n}\n\n@media (min-width: 480px) {\n    .hero-section {\n        min-height: 50vh;\n    }\n}\n\n@media (min-width: 640px) {\n    .hero-section {\n        min-height: 55vh;\n    }\n}\n\n@media (min-width: 1024px) {\n    .hero-section {\n        height: 71vh;\n        background-size: center;\n        background-position: 50% 60%;\n    }\n}\n\n.bg-sponsor {\n    background: url(\"./assets/Sponsor-section.png\");\n    width: 100vw;\n    height: auto;\n    object-fit: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n@media (min-width: 1024px) {\n    .bg-sponsor {\n        background-position: 30% 50%;\n        background-size: contain;\n    }\n}\n\n.bg-ai {\n    background: url(\"./assets/ai-section.svg\");\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n}\n\n@media (min-width: 1024px) {\n    .bg-ai {\n        background-position: 30% 50%;\n        background-size: contain;\n    }\n}\n\n.search-component {\n    display: flex;\n    align-items: center;\n    padding: 4px 8px;\n    background-color: #ffffff;\n    border: 1px solid #FFFFFF00;\n    border-radius: 10px;\n    box-shadow: 0 0 0 1px #0A0919,\n                0 2px 3px #FFFFFF00;\n    overflow: hidden;\n    width: 100%;\n    max-width: 100%;\n}\n\n@media (min-width: 480px) {\n    .search-component {\n        padding: 5px 10px;\n        border-radius: 12px;\n    }\n}\n\n@media (min-width: 640px) {\n    .search-component {\n        padding: 5px 15px;\n    }\n}\n  \n  .search-icon {\n    /* Styling for your icon */\n    margin-right: 10px;\n    width: 28.19px; /* Adjust size */\n    height: 28.19px; /* Adjust size */\n    background: linear-gradient(to top, #0A05F854, #fff); /* Example gradient for the icon */\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center; \n    animation: slideGradient 5s linear infinite;\n\n }\n @keyframes slideGradient {\n    0% { background-position: 0% 0%; }\n    100% { background-position: 100% 0%; }\n  }\n  .search-input {\n    flex-grow: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    padding: 2px 0;\n    font-size: 11px;\n    font-weight: 400;\n    color: #313233;\n    min-width: 0;\n  }\n\n  .search-input:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n  }\n\n  @media (min-width: 480px) {\n    .search-input {\n        font-size: 12px;\n        padding: 10px 0;\n    }\n  }\n\n  @media (min-width: 640px) {\n    .search-input {\n        font-size: 14px;\n        padding: 12px 0;\n    }\n  }\n  \n  .chat-button {\n    background-color: #000000;\n    color: white;\n    border: none;\n    border-radius: 20px;\n    padding: 6px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    margin-left: 6px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n    min-height: 32px;\n  }\n\n  .chat-button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  .chat-button:hover:not(:disabled) {\n    background-color: #333333;\n    transform: translateY(-1px);\n  }\n\n  @media (min-width: 480px) {\n    .chat-button {\n        padding: 7px 12px;\n        font-size: 13px;\n        border-radius: 24px;\n        min-height: 36px;\n    }\n  }\n\n  @media (min-width: 640px) {\n    .chat-button {\n        padding: 10px 20px;\n        font-size: 16px;\n        margin-left: 15px;\n        border-radius: 28px;\n        min-height: 40px;\n    }\n  }\n\n/* Additional mobile responsive utilities */\n@media (max-width: 639px) {\n  .mobile-hidden {\n    display: none !important;\n  }\n  \n  .mobile-full-width {\n    width: 100% !important;\n  }\n  \n  .mobile-text-sm {\n    font-size: 0.875rem !important;\n  }\n  \n  .mobile-p-2 {\n    padding: 0.5rem !important;\n  }\n  \n  .mobile-gap-2 {\n    gap: 0.5rem !important;\n  }\n}\n\n/* Ensure proper touch targets on mobile */\n@media (max-width: 639px) {\n  button, .clickable {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  input, textarea {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n\n/* Responsive container utilities */\n.container-responsive {\n  width: 100%;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n@media (min-width: 640px) {\n  .container-responsive {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container-responsive {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n/* Global input styling */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"tel\"],\ninput[type=\"number\"],\ntextarea {\n  width: 100%;\n  height: 48px;\n  /* padding: 12px 16px; */\n  /* border: 1px solid #D1D5DB; */\n  border-radius: 12px;\n  font-size: 13px;\n  font-family: 'DM Sans', sans-serif;\n  outline: none;\n  /* background-color: #FFFFFF; */\n  color: #374151;\n  transition: border-color 0.2s ease;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"tel\"]:focus,\ninput[type=\"number\"]:focus,\ntextarea:focus {\n  border-color: #2563EB;\n  /* box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); */\n}\n\ntextarea {\n  height: auto;\n  min-height: 48px;\n  resize: vertical;\n}\n\n/* Google button styling */\n.google-button {\n  width: 100%;\n  height: 48px;\n  background-color: #FFFFFF;\n  border: 1px solid #D1D5DB;\n  border-radius: 12px;\n  color: #374151;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.google-button:hover {\n  background-color: #F9FAFB;\n}\n\n/* Sidebar scrollbar — thin, neutral track */\n.dockie-sidebar-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #d4d4d4 transparent;\n}\n\n.dockie-sidebar-scroll::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dockie-sidebar-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.dockie-sidebar-scroll::-webkit-scrollbar-thumb {\n  background-color: #d4d4d4;\n  border-radius: 999px;\n}\n\n.dockie-sidebar-scroll::-webkit-scrollbar-thumb:hover {\n  background-color: #a3a3a3;\n}\n\n/* Live voice chat wave animations */\n@keyframes voice-wave-drift-left {\n  0%,\n  100% {\n    transform: translateY(3px) scaleY(0.92);\n  }\n  35% {\n    transform: translateY(-5px) scaleY(1.04);\n  }\n  70% {\n    transform: translateY(-1px) scaleY(0.98);\n  }\n}\n\n@keyframes voice-wave-drift-mid {\n  0%,\n  100% {\n    transform: translateY(1px) scaleY(0.9);\n  }\n  45% {\n    transform: translateY(-7px) scaleY(1.08);\n  }\n  80% {\n    transform: translateY(-2px) scaleY(1);\n  }\n}\n\n@keyframes voice-wave-drift-right {\n  0%,\n  100% {\n    transform: translateY(2px) scaleY(0.94);\n  }\n  40% {\n    transform: translateY(-6px) scaleY(1.06);\n  }\n  75% {\n    transform: translateY(0) scaleY(0.97);\n  }\n}\n\n@keyframes voice-wave-subtle-drift {\n  0%,\n  100% {\n    transform: translateY(1px) scaleY(0.85);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translateY(-2px) scaleY(1);\n    opacity: 1;\n  }\n}\n\n@keyframes voice-note-dot-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 0.35;\n  }\n  50% {\n    transform: scale(1.35);\n    opacity: 1;\n  }\n}\n\n@keyframes voice-note-bar-pulse {\n  0%,\n  100% {\n    transform: scaleY(0.45);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n}\n\n.voice-chat-wave-svg {\n  transform-origin: center bottom;\n  will-change: transform;\n}\n\n.voice-chat-waves-mask {\n  -webkit-mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(0, 0, 0, 0.35) 6%,\n    #000 14%,\n    #000 86%,\n    rgba(0, 0, 0, 0.35) 94%,\n    transparent 100%\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(0, 0, 0, 0.35) 6%,\n    #000 14%,\n    #000 86%,\n    rgba(0, 0, 0, 0.35) 94%,\n    transparent 100%\n  );\n}\n\n.voice-chat-wave-svg--back {\n  animation: voice-wave-sway-back 2.6s ease-in-out infinite;\n}\n\n.voice-chat-wave-svg--mid {\n  animation: voice-wave-sway-mid 2.2s ease-in-out infinite;\n}\n\n.voice-chat-wave-svg--front {\n  animation: voice-wave-sway-front 2s ease-in-out infinite;\n}\n\n.voice-chat-wave-svg--subtle {\n  animation: voice-wave-sway-subtle 2.4s ease-in-out infinite;\n}\n\n@keyframes voice-wave-sway-back {\n  0%,\n  100% {\n    transform: translateX(0) scaleY(0.96);\n  }\n  50% {\n    transform: translateX(-0.8%) scaleY(1.02);\n  }\n}\n\n@keyframes voice-wave-sway-mid {\n  0%,\n  100% {\n    transform: translateX(0) scaleY(0.94);\n  }\n  50% {\n    transform: translateX(0.8%) scaleY(1.04);\n  }\n}\n\n@keyframes voice-wave-sway-front {\n  0%,\n  100% {\n    transform: translateX(0) scaleY(0.95);\n  }\n  50% {\n    transform: translateX(-0.5%) scaleY(1.03);\n  }\n}\n\n@keyframes voice-wave-sway-subtle {\n  0%,\n  100% {\n    transform: translateX(0) scaleY(0.92);\n    opacity: 0.65;\n  }\n  50% {\n    transform: translateX(0.5%) scaleY(0.98);\n    opacity: 0.9;\n  }\n}\n\n.voice-chat-wave-layer {\n  height: 14px;\n  border-radius: 999px 999px 0 0;\n  transform-origin: bottom center;\n  will-change: transform;\n}\n\n.voice-chat-wave-layer--back {\n  background: linear-gradient(180deg, #bfdbfe 0%, #93c5fd 100%);\n  animation: voice-wave-drift-left 2.4s ease-in-out infinite;\n}\n\n.voice-chat-wave-layer--mid {\n  background: linear-gradient(180deg, #60a5fa 0%, #3b82f6 100%);\n  animation: voice-wave-drift-mid 2s ease-in-out infinite;\n}\n\n.voice-chat-wave-layer--front {\n  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);\n  animation: voice-wave-drift-right 2.2s ease-in-out infinite;\n}\n\n.voice-chat-wave-layer--subtle {\n  background: linear-gradient(180deg, #dbeafe 0%, #bfdbfe 100%);\n  animation: voice-wave-subtle-drift 2s ease-in-out infinite;\n}\n\n.voice-flow-wave-layer {\n  transform-box: fill-box;\n  transform-origin: center bottom;\n  will-change: transform;\n}\n\n.voice-flow-wave-layer--back {\n  animation: voice-flow-wave-back 4.8s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n}\n\n.voice-flow-wave-layer--middle {\n  animation: voice-flow-wave-middle 4.1s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n}\n\n.voice-flow-wave-layer--front {\n  animation: voice-flow-wave-front 3.6s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n}\n\n@keyframes voice-flow-wave-back {\n  0%,\n  100% {\n    transform: translateX(-0.5%) scaleX(1.02) scaleY(0.92);\n  }\n  34% {\n    transform: translateX(0.3%) scaleX(1.02) scaleY(1.07);\n  }\n  68% {\n    transform: translateX(-0.1%) scaleX(1.02) scaleY(0.98);\n  }\n}\n\n@keyframes voice-flow-wave-middle {\n  0%,\n  100% {\n    transform: translateX(0.4%) scaleX(1.02) scaleY(0.96);\n  }\n  38% {\n    transform: translateX(-0.3%) scaleX(1.02) scaleY(1.08);\n  }\n  72% {\n    transform: translateX(0.1%) scaleX(1.02) scaleY(0.9);\n  }\n}\n\n@keyframes voice-flow-wave-front {\n  0%,\n  100% {\n    transform: translateX(-0.2%) scaleX(1.02) scaleY(0.9);\n  }\n  42% {\n    transform: translateX(0.25%) scaleX(1.02) scaleY(1.04);\n  }\n  76% {\n    transform: translateX(-0.1%) scaleX(1.02) scaleY(0.96);\n  }\n}\n\n.voice-note-dot {\n  animation: voice-note-dot-pulse 1s ease-in-out infinite;\n}\n\n.voice-note-bar {\n  transform-origin: bottom center;\n  animation: voice-note-bar-pulse 0.9s ease-in-out infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
